export const translations = {
  es: {
    // ── Perfil ──
    perfil_titulo: 'Mi Perfil',
    perfil_subtitulo: 'Configuración de usuario',
    cambiar_foto: '📷 Cambiar foto',
    idioma_titulo: '🌐 Idioma',
    idioma_desc: 'Elige el idioma en el que quieres ver la aplicación.',
    canjear_codigo: 'Canjear código',
    canjear_placeholder: '🎁 Ingresa tu código',
    canjear_validando: 'Validando...',
    canjear_boton: 'Canjear código',
    id_amigo_titulo: '🆔 ID de amigo',
    id_amigo_desc: 'Este ID será utilizado para que otros usuarios puedan agregarte como amigo.',
    no_generado: 'No generado',
    regenerar: '🔄 Regenerar',
    generar: '⚡ Generar',
    correo_titulo: '📧 Correo electrónico',
    correo_desc: 'Si cambias tu correo, recibirás un email de confirmación.',
    editar: '✏️ Editar',
    bloquear: '🔒 Bloquear',
    nombre_titulo: '✏️ Nombre visible',
    nombre_desc: 'Este nombre será el que verá el usuario en la aplicación.',
    nombre_placeholder: 'Tu nombre visible',
    vista_titulo: '👁️ Vista preferida',
    vista_desc_pre: 'Guarda qué vista de tu dinero prefieres al entrar al home, si',
    vista_mensual: 'mensual',
    vista_general: 'general',
    vista_general_activa: '🌎 Vista general activada',
    vista_mensual_activa: '📅 Vista mensual activada',
    color_titulo: '🎨 Color de la app',
    color_desc: 'Elige la paleta visual de toda la aplicación.',
    activo: '✓ Activo',
    toca_aplicar: 'Toca para aplicar',
    temas_titulo: '🎭 Temas',
    temas_desc: 'Cambia completamente la apariencia de la aplicación.',
    sin_temas: 'Aún no has desbloqueado ningún tema. Canjea un código para desbloquear uno 🎁',
    moneda_titulo: '💱 Moneda de la app',
    moneda_desc: 'Elige en qué moneda se muestran los precios en toda la aplicación.',
    moneda_aviso: '⚠️ Los montos almacenados pueden variar si cambias de moneda. Los valores históricos se recalcularán utilizando la tasa de cambio actual, por lo que podrían presentar pequeñas diferencias. Se recomienda utilizar una sola moneda y evitar cambiarla, salvo que sea realmente necesario. Nota: la tasa de conversión se actualiza cada 6 horas. Ten esto en cuenta antes de realizar una conversión, ya que el valor mostrado puede diferir ligeramente del que se aplicará en futuras actualizaciones.',
    sesiones_titulo: '🔐 Sesiones activas',
    sesiones_desc: 'Dispositivos donde tienes sesión abierta. Cierra las que no reconozcas.',
    cargando_sesiones: 'Cargando sesiones...',
    sin_sesiones: 'Sin sesiones registradas',
    esta_sesion: 'Esta sesión',
    cerrar: 'Cerrar',
    cerrar_otras_sesiones: '🔒 Cerrar todas las otras sesiones',
    ultimo_acceso: 'Último acceso',
    tiempo_ahora: 'Ahora mismo',
    tiempo_min: 'Hace {n} min',
    tiempo_hora: 'Hace {n}h',
    tiempo_dia: 'Hace {n}d',
    password_titulo: '🔑 Cambiar contraseña',
    password_desc_pre: 'Te enviaremos un correo a',
    password_desc_post: 'con un enlace para cambiar tu contraseña.',
    enviar_enlace: '📧 Enviar enlace de cambio',
    creadores: 'Creadores',
    guardar: '💾 Guardar cambios',
    guardando: 'Guardando cambios...',

    // ── Home ──
    proximamente: 'Próximamente',
    modo_negocio: 'Modo 🏪 Negocio',
    modo_personal: 'Modo 👤 Personal',
    amigos: 'Amigos',
    notificaciones: 'Notificaciones',
    marcar_todo_leido: 'Marcar todo leído',
    sin_notificaciones: 'No tienes notificaciones',
    aceptar: '✅ Aceptar',
    rechazar: '❌ Rechazar',
    aceptar_eliminar: '🗑️ Aceptar y eliminar',
    rechazar_simple: '✕ Rechazar',
    ver_ahorro_responder: '📳 Ver el ahorro y responder',
    alertas: 'Alertas',
    cerrar_sesion: 'Cerrar sesión',
    saludo_mundial: '🏆 Bienvenid@,',
    saludo_normal: '¡Hola,',
    bonzai_bot: 'BONZAI BOT 💬',
    alertas_pendientes_pre: '🚨 Tienes',
    alertas_pendientes_post: 'alerta(s) pendiente(s)',
    ahora_mismo: 'ahora mismo',
    muro_sugerencias: 'Ver muro de sugerencias',
    periodo_titulo: '📅 ¡Escoge el período financiero que quieras!',
    periodo_desc: 'Filtra tus estadísticas por mes o visualiza todo',
    vista_general_btn: '🌎 Vista general',
    vista_mensual_btn: '📅 Vista mensual',
    resumen: 'Resumen',
    ingresos_totales: 'INGRESOS TOTALES',
    ingresos_del_mes: 'INGRESOS DEL MES',
    gastos_totales: 'GASTOS TOTALES',
    gastos_del_mes: 'GASTOS DEL MES',
    tap_registrar_ingreso: 'CLICK PARA REGISTRAR 💵',
    tap_registrar_gasto: 'CLICK PARA REGISTRAR 🧾',
    balance_general: 'BALANCE GENERAL',
    balance_positivo: 'Vas bien. Tus ingresos están ganando la pelea.',
    balance_negativo: 'Tus gastos andan haciendo speedrun con tu dinero.',
    balance_neutro: 'Perfectamente equilibrado... como una billetera zen.',
    tap_ver_analisis: 'CLICK PARA VER ANÁLISIS 📊',
    elemento_destacado: 'ELEMENTO DESTACADO',
    meta: 'Meta:',
    restante: 'Restante:',
    tap_ver_deudas: 'CLICK PARA VER DEUDAS ',
    tap_ver_ahorros: 'CLICK PARA VER AHORROS ',
    compartido: '👥 Compartido',
    tap_crear_ahorro: 'CLICK PARA CREAR UN AHORRO',
    nav_calendario: 'Calendario',
    nav_amigos: 'Amigos',
    nav_mensajes: 'Mensajes',
    nav_ia: 'I.A',
    cargando_mundial: 'Preparando el partido...',
    cargando_normal: 'Cargando tu información...',

    //Ingresos
    ingresos_header: '💵 Ingresos',
    volver: '← Volver',
    total_ingresos: 'Total ingresos',
    monto_placeholder: 'Monto',
    selecciona_categoria: 'Selecciona una categoría',
    cat_principales: '💼 Ingresos principales',
    cat_salario: 'Salario',
    cat_honorarios: 'Honorarios',
    cat_negocio_propio: 'Negocio propio',
    cat_adicionales: '✨ Ingresos adicionales',
    cat_horas_extra: 'Horas extra',
    cat_comisiones: 'Comisiones',
    cat_bonificaciones: 'Bonificaciones',
    cat_ocasionales: '🎁 Ingresos ocasionales',
    cat_primas: 'Primas',
    cat_cesantias: 'Cesantías',
    cat_regalos: 'Regalos o ayudas familiares',
    cat_personalizado: '➕ Personalizado',
    cat_otro: 'Otro',
    titulo_categoria_placeholder: 'Título de tu categoría',
    descripcion_placeholder: 'Descripción',
    agregar_ingreso: 'Agregar ingreso',
    csv_pregunta: '¿Ya tienes un CSV?',
    csv_respuesta: '¡La app lo leerá automáticamente!',
    csv_elige_banco: 'Elige tu banco y sube el archivo',
    csv_importar_titulo: 'Importar CSV',
    selecciona_pais: 'SELECCIONA TU PAÍS',
    selecciona_banco: 'SELECCIONA TU BANCO',
    cambiar_pais: 'Cambiar país',
    cargar_csv_de: 'Cargar CSV de',
    selecciona_banco_primero: 'Selecciona un banco primero',
    primero_selecciona_banco: 'Primero selecciona un banco',
    cerrar_modal: 'Cerrar',
    ingresos_detectados: 'Ingresos detectados',
    revisa_antes_importar: 'Revisa antes de importar. Solo se incluyen créditos/ingresos.',
    sin_descripcion: 'Sin descripción',
    importando: 'Importando...',
    importar_n_ingresos: 'Importar',
    cancelar: 'Cancelar',
    filtrar_categoria: '🔍 Filtrar por categoría',
    todas_categorias: 'Todas las categorías',
    buscar_cat_personalizada: 'Buscar categoría personalizada...',
    escribir_nombre_cat: 'Escribe el nombre de la categoría...',
    resultado: 'resultado',
    resultados: 'resultados',
    para_texto: 'para',
    en_texto: 'en',
    limpiar_filtro: '✕ Limpiar filtro',
    sin_ingresos_categoria: 'No hay ingresos con esta categoría en el período seleccionado.',
    sin_ingresos: 'No hay ingresos registrados',
    sin_categoria: 'Sin categoría',
    guardar_edicion: '✔ Guardar',
    cancelar_edicion: '✖ Cancelar',
    eliminar_registro_titulo: '¿Eliminar este registro?',
    eliminar_registro_desc: 'Esta acción no se puede deshacer.',
    si_eliminar: 'Sí, eliminar',

    //Gastos
    gastos_header: '💸 Gastos',
    total_gastos: 'Total gastos',
    agregar_gasto: 'Agregar Gasto',
    cat_fijos: '🏠 Gastos fijos',
    cat_arriendo: 'Arriendo',
    cat_administracion: 'Administración',
    cat_servicios: '⚡ Servicios públicos',
    cat_agua: 'Agua',
    cat_luz: 'Luz',
    cat_gas: 'Gas',
    cat_internet: 'Internet',
    cat_basicos: '🍽️ Gastos básicos',
    cat_mercado: 'Mercado',
    cat_alimentacion: 'Alimentación',
    cat_transporte: 'Transporte',
    cat_deudas: '💳 Deudas y obligaciones',
    cat_tarjetas: 'Tarjetas de crédito',
    cat_creditos: 'Créditos',
    cat_salud: '🏥 Salud y protección',
    cat_eps: 'EPS',
    cat_medicina_prepagada: 'Medicina prepagada',
    cat_personales: '📱 Gastos personales',
    cat_celular: 'Celular',
    cat_streaming: 'Streaming (Netflix, Spotify, etc.)',
    cat_ropa: 'Ropa',
    cat_ocio: '🎉 Ocio y estilo de vida',
    cat_salidas: 'Salidas (restaurantes, cine, rumba)',
    cat_viajes: 'Viajes',
    csv_pregunta_gastos: '¿Ya tienes un CSV?',
    csv_respuesta_gastos: '¡La app importará tus gastos automáticamente!',
    gastos_detectados: 'Gastos detectados',
    revisa_antes_importar_gastos: 'Revisa antes de importar. Solo se incluyen débitos/gastos.',
    sin_gastos_categoria: 'No hay gastos con esta categoría en el período seleccionado.',
    sin_gastos: 'No hay Gastos registrados',
    importar_n_gastos: 'Importar',
    no_se_encontraron_gastos: 'No se encontraron gastos válidos. Verifica que el archivo sea de',

    //Ahorros — header / general
    ahorros_header: '💰 Ahorros / Deudas',
    ahorros_disponible: '💵 Disponible',
    ahorros_total_ahorrado: '🐷 Total ahorrado',
    ahorros_nuevo_btn: '➕ Nuevo ahorro o deuda',
    ahorros_loading_title: 'Ahorros & Deudas',
    ahorros_loading_desc: 'Preparando tus movimientos...',

    //Ahorros — secciones
    ahorros_personales: '👤 Personales',
    ahorros_compartidos: '👥 Compartidos',
    ahorros_sin_compartidos: 'Sin ahorros compartidos aún',
    ahorros_sin_ahorros_titulo: 'Sin ahorros aún',
    ahorros_sin_ahorros_desc: 'Crea tu primer ahorro o deuda arriba',

    //Ahorros — tipo
    ahorro_tipo_deuda: '🔴 Deuda',
    ahorro_tipo_ahorro: '🟠 Ahorro',
    ahorro_tipo_seguimiento_deuda: '🔴 Seguimiento de deuda',
    ahorro_tipo_ahorro_compartido: '🟠 Ahorro compartido',

    //Ahorros — compartidos / estados
    ahorro_pendiente: '⏳ Pendiente',
    ahorro_activo: '✅ Activo',
    ahorro_compartido_badge: '👥 Compartido',
    ahorro_zumbido_btn: '📳 Zumbido',
    ahorro_zumbido_title: 'Enviar zumbido a',
    ahorro_con: 'Con',
    ahorro_de: 'De',
    ahorro_solo_lectura: '👁 Solo lectura',
    ahorro_total_pagado: '💰 Total pagado',
    ahorro_tu_aporte: 'Tu aporte',
    ahorro_su_aporte: 'Su aporte',
    ahorro_esperando_acepte_pre: 'Esperando que',
    ahorro_esperando_acepte_post: 'acepte la invitación',
    ahorro_tu_amigo: 'tu amigo',

    //Ahorros — completados
    ahorros_completados_1: '1 completado',
    ahorros_completados_n: '{n} completados',
    ahorros_buscar_placeholder: '🔍 Buscar...',
    ahorros_sin_resultados: 'No se encontraron resultados',
    ahorro_completado_badge: '🎉 Completado',
    ahorro_eliminar_btn: '🗑️ Eliminar',

    //Ahorros — modal crear
    ahorro_modal_nuevo_ahorro: '🟠 Nuevo ahorro',
    ahorro_modal_nueva_deuda: '🔴 Nueva deuda',
    ahorro_nombre_placeholder: 'Nombre *',
    ahorro_descripcion_placeholder: 'Descripción (opcional)',
    ahorro_meta_placeholder: 'Meta en $ (opcional)',
    ahorro_compartir_amigo: '👥 Compartir con amigo',
    ahorro_compartir_desc_deuda: 'El amigo verá cómo le pagas',
    ahorro_compartir_desc_ahorro: 'Ambos pueden aportar',
    ahorro_sin_amigos: '⚠️ No tienes amigos agregados aún',
    ahorro_usuario_generico: 'Usuario',
    ahorro_id_label: 'ID:',
    ahorro_creando: 'Creando...',
    ahorro_guardar_btn: '💾 Guardar',

    //Ahorros — modal movimiento personal
    ahorro_acumulado: 'acumulado',
    ahorro_monto_placeholder: '💰 Ingresa una cantidad',
    ahorro_comprobante_opcional: '📎 Comprobante (opcional)',
    ahorro_subir_imagen: '📷 Subir imagen',
    ahorro_subiendo: 'Subiendo...',
    ahorro_meter_dinero: '➕ Meter dinero',
    ahorro_sacar_dinero: '➖ Sacar dinero',

    //Ahorros — confirmar eliminar
    ahorro_confirmar_eliminar_titulo: '¿Eliminar este ahorro?',
    ahorro_confirmar_eliminar_desc: 'El dinero acumulado volverá a tu balance principal.',

    //Ahorros — modal movimiento compartido
    ahorro_historial: 'HISTORIAL',
    ahorro_ver_comprobante_title: 'Ver comprobante',
    ahorro_deuda_saldada: '¡Deuda saldada!',
    ahorro_meta_alcanzada: '¡Meta alcanzada!',
    ahorro_pagaste_todo: 'Pagaste todo. ¡Libre de deudas! 💪',
    ahorro_meta_lograda_juntos: 'Lograron el objetivo juntos. ¡Felicitaciones! 🚀',
    ahorro_comprobante_pago: '📎 Comprobante de pago',
    ahorro_obligatorio: '* Obligatorio',
    ahorro_subir_comprobante: '📷 Subir comprobante',
    ahorro_registrar_pago: '➕ Registrar pago',
    ahorro_solicitar_eliminacion: '🗑️ Solicitar eliminación',
    ahorro_modo_observador: 'Modo observador',
    ahorro_modo_observador_desc: 'Solo el creador puede registrar pagos en esta deuda',

    //Ahorros — toasts
    toast_ahorro_ponle_nombre: 'Ponle nombre al ahorro',
    toast_nombre_max_50: 'El nombre no puede tener más de 50 caracteres',
    toast_desc_max_200: 'La descripción no puede tener más de 200 caracteres',
    toast_selecciona_amigo: 'Selecciona un amigo',
    toast_error_crear: 'Error al crear',
    toast_solicitud_enviada_a: 'Solicitud enviada a',
    toast_demasiadas_solicitudes: 'Demasiadas solicitudes enviadas. Espera un momento antes de volver a intentarlo.',
    toast_cantidad_invalida: 'Cantidad inválida',
    toast_sin_dinero_disponible: 'No tienes suficiente dinero disponible',
    toast_sin_suficiente_ahorro: 'No tienes suficiente en este ahorro',
    toast_solo_hasta_meta: 'Solo puedes ingresar hasta {monto} para completar la meta',
    toast_solo_creador_pagos_deuda: 'Solo el creador puede registrar pagos en una deuda',
    toast_debes_subir_comprobante: 'Debes subir un comprobante de pago',
    toast_error_subir_comprobante: 'Error al subir comprobante',
    toast_excede_meta: '⚠️ Solo puedes aportar hasta {monto} para completar la meta',
    toast_no_autorizado: '🚫 No tienes permiso para registrar pagos en este ahorro',
    toast_solo_creador_deuda: '🚫 Solo el creador puede registrar pagos en esta deuda',
    toast_no_activo: '⚠️ Este ahorro no está activo aún',
    toast_no_existe: '⚠️ Este ahorro no existe',
    toast_error_registrar_pago: '⚠️ Ocurrió un error al registrar el pago',
    toast_demasiadas_solicitudes_warn: '⚠️ Demasiadas solicitudes enviadas. Espera un momento antes de volver a intentarlo.',
    toast_ahorro_eliminado: 'Ahorro eliminado correctamente',
    toast_solicitud_eliminacion_enviada: 'Solicitud de eliminación enviada. El otro usuario debe aceptarla.',
    toast_zumbido_error: '⚠️ No se pudo enviar el zumbido, intenta de nuevo.',
    toast_zumbido_enviado: '¡Zumbido enviado! 📳',
    toast_imagen_invalida: 'Solo se permiten imágenes JPG, PNG, WebP o HEIC',
    toast_imagen_max_mb: 'La imagen no puede pesar más de {mb}MB',

    //Ahorros — notificaciones guardadas para el otro usuario
    noti_invito_a_pre: 'te invitó a un',
    noti_seguimiento_deuda: 'seguimiento de deuda',
    noti_ahorro_compartido: 'ahorro compartido',
    noti_sin_descripcion: 'Sin descripción',
    noti_alguien: 'Alguien',
    noti_eliminar_titulo_pre: '🗑️',
    noti_quiere_eliminar: 'quiere eliminar',
    noti_solicita_eliminar_pre: 'Solicita eliminar este',
    noti_solicita_eliminar_post: 'completado. ¿Estás de acuerdo?',
    noti_tu_companero: 'Tu compañero',
    noti_nuevo_aporte: 'Nuevo',
    noti_aporte: 'aporte',
    noti_retiro: 'retiro',
    noti_en: 'en',
    noti_aporto: 'aportó',
    noti_retiro_verbo: 'retiró',
    noti_toca_ver_comprobante: 'Toca para ver el comprobante.',
    noti_zumbido_titulo: 'Te envió un Zumbido!',
    noti_revisa_tu: 'Revisa tu:',
    //Alertas
    alertas_header: '⚠️ Alertas',
    alertas_activas: 'Alertas activas',
    alertas_nombre_placeholder: 'Nombre de la alerta',
    alertas_valor_placeholder: 'Valor a pagar',
    alertas_mora_placeholder: '% mora diaria',
    alertas_crear_btn: 'Crear alerta',
    alertas_sin_registradas: 'No hay alertas registradas',
    alertas_valor_original: 'Valor original',
    alertas_mora_diaria: 'Mora diaria',
    alertas_fecha_limite: 'Fecha límite',
    alertas_retraso_pre: '⚠️ Retraso de',
    alertas_retraso_post: 'días',
    alertas_nuevo_valor: 'Nuevo valor:',
    alertas_confirmar_eliminar: '¿Eliminar esta alerta?',
    alertas_campos_obligatorios: 'Completa todos los campos obligatorios',
    alertas_nombre_max_50: 'El nombre no puede tener más de 50 caracteres',
    alertas_desc_max_200: 'La descripción no puede tener más de 200 caracteres',
    toast_error_guardar_alerta: 'Error al guardar alerta',
    //Analíticas
    analiticas_header: '📊 Analíticas',
    analiticas_subtitulo: 'Resumen financiero inteligente',
    analiticas_cargando: 'Cargando analíticas...',
    analiticas_ingresos: 'Ingresos',
    analiticas_gastos: 'Gastos',
    analiticas_ahorro: 'Ahorro',
    analiticas_mejor_mes: 'Mejor mes',
    analiticas_rendimiento_anual: '📈 Rendimiento anual',
    analiticas_recomendaciones: '🧠 Recomendaciones Inteligentes',
    analiticas_mejor_mes_desc_pre: '💰 Tu mejor mes fue',
    analiticas_mejor_mes_desc_post: ', donde obtuviste mayores ingresos.',
    analiticas_peor_mes_desc_pre: '⚠️ Tu mes con más gastos fue',
    analiticas_ahorro_total_pre: '🎯 Actualmente has ahorrado un total de',
    analiticas_ahorro_total_post: 'este año.',
    consejo_gastos_superan: '⚠️ Tus gastos superan tus ingresos. Reduce gastos innecesarios.',
    consejo_excelente: '🔥 Excelente manejo financiero. Tu ahorro es bastante alto.',
    consejo_vas_bien: '✅ Vas bien. Tienes una buena capacidad de ahorro.',
    consejo_reducir_gastos: '💡 Intenta reducir gastos pequeños diarios para mejorar tu ahorro.',
    mes_ene: 'Ene', mes_feb: 'Feb', mes_mar: 'Mar', mes_abr: 'Abr',
    mes_may: 'May', mes_jun: 'Jun', mes_jul: 'Jul', mes_ago: 'Ago',
    mes_sep: 'Sep', mes_oct: 'Oct', mes_nov: 'Nov', mes_dic: 'Dic',
    //Amigos
    amigos_sincronizando: 'Sincronizando conexiones...',
    amigos_volver: '← Volver',
    amigos_gestiona: 'Gestiona tus conexiones',
    amigos_agregar_titulo: '➕ Agregar amigo',
    amigos_agregar_desc: 'Comparte tu ID con otra persona o agrega el suyo.',
    amigos_tu_id: 'TU ID',
    amigos_sin_id_pre: '⚠️ No has creado un ID de amigo aún.',
    amigos_sin_id_post: 'Ve a Perfil y genera tu ID para poder agregar amigos.',
    amigos_input_placeholder: 'Ingresa el ID del usuario',
    amigos_enviando: 'Enviando...',
    amigos_anadir_btn: '🚀 Añadir amigo',
    amigos_solicitudes_titulo: '📩 Solicitudes pendientes',
    amigos_sin_solicitudes: 'No tienes solicitudes pendientes',
    amigos_aceptar: '✅ Aceptar',
    amigos_rechazar: '❌ Rechazar',
    amigos_usuario_generico: 'Usuario',
    amigos_sin_id: 'Sin ID',
    amigos_tus_amigos_titulo: '👥 Tus amigos',
    amigos_sin_amigos: 'Aún no tienes amigos agregados',
    amigos_editar: '✏️ Editar',
    amigos_eliminar: '🗑️ Eliminar',
    amigos_nombre_personalizado: '✏️ Nombre personalizado',
    amigos_alias_placeholder: 'Escribe un alias',
    amigos_cancelar: 'Cancelar',
    amigos_guardar_amigo: '💾 Guardar amigo',
    amigos_confirmar_eliminar_titulo: '¿Eliminar este amigo?',
    amigos_confirmar_eliminar_desc: 'Esta acción no se puede deshacer.',
    amigos_si_eliminar: 'Sí, eliminar',
    amigos_alert_ingresa_id: 'Ingresa un ID',
    amigos_alert_no_existe: 'No existe un usuario con ese ID',
    amigos_alert_no_agregarte: 'No puedes agregarte a ti mismo',
    amigos_alert_ya_existe: 'Ya existe una solicitud o amistad',
    amigos_alert_error_enviar: 'No se pudo enviar la solicitud',
    amigos_alert_demasiadas: '⚠️ Enviaste demasiadas solicitudes seguidas. Espera un minuto e intenta de nuevo.',
    amigos_alert_enviada: 'Solicitud enviada 🚀',
    amigos_alert_nickname_max: 'El nombre personalizado no puede tener más de 30 caracteres',
    amigos_alert_error_aceptar: 'No se pudo aceptar la solicitud',
    amigos_alert_amigo_agregado: '🎉 Amigo agregado',
    amigos_alert_error_eliminar: 'No se pudo eliminar el amigo',
    amigos_alert_amigo_eliminado: '🗑️ Amigo eliminado',
    amigos_alert_error_rechazar: 'No se pudo rechazar',
    mensajes_header: 'Mensajes',
    //Mensajes
    sin_conversaciones: 'Sin conversaciones',
    agrega_amigos_chatear: 'Agrega amigos para chatear',
    sin_mensajes_aun: 'Sin mensajes aún',
    tu_dos_puntos: 'Tú: ',
    no_hay_mensajes_decir_hola: 'No hay mensajes aún. ¡Di hola! 👋',
    escribir_mensaje_placeholder: 'Escribe un mensaje...',
    usuario_generico: 'Usuario',
    cargando_mensajes: 'Cargando mensajes...',
    cal_movimientos_dia: 'Movimientos día {dia}',
    //Calendario
    cal_agregar_ingreso: '➕ Agregar Ingreso',
    cal_agregar_gasto: '➕ Agregar Gasto',
    cal_no_hay_movimientos: 'No hay movimientos',
    cal_mora_diaria_valor: 'Mora diaria: {pct}%',
    cal_seleccionar_fecha: '📅 Seleccionar fecha',
    cal_mes_label: 'Mes',
    cal_anio_label: 'Año',
    cal_aplicar: 'Aplicar',
    cal_enero: 'Enero', cal_febrero: 'Febrero', cal_marzo: 'Marzo', cal_abril: 'Abril',
    cal_mayo: 'Mayo', cal_junio: 'Junio', cal_julio: 'Julio', cal_agosto: 'Agosto',
    cal_septiembre: 'Septiembre', cal_octubre: 'Octubre', cal_noviembre: 'Noviembre', cal_diciembre: 'Diciembre',
    dia_lun: 'L', dia_mar: 'M', dia_mie: 'M', dia_jue: 'J', dia_vie: 'V', dia_sab: 'S', dia_dom: 'D',
    //BonzaiBot
    // ── Factura Scanner ──
    factura_btn_label: 'FACTURA',
    factura_tooltip: '📄 Escanear factura (QR + IA)',
    factura_tomar_foto: '📸 Tomar foto',
    factura_elegir_galeria: '🖼️ Elegir de galería',
    factura_ingresar_manual: '✏️ Ingresar manual',
    factura_qr_detectado: '✅ QR detectado',
    factura_analizada: '🤖 Factura analizada',
    factura_ingresa_datos: '✏️ Ingresa los datos',
    factura_no_pudo_leer: 'No se pudo leer automáticamente. Completa los datos.',
    factura_verifica_datos: 'Verifica los datos antes de guardar',
    factura_monto_total: 'MONTO TOTAL *',
    factura_categoria_label: 'CATEGORÍA *',
    factura_nombre_categoria: 'NOMBRE DE TU CATEGORÍA',
    factura_categoria_custom_placeholder: 'Ej: Mascotas, Gym, Regalo...',
    factura_fecha_label: 'FECHA',
    factura_desc_label: 'DESCRIPCIÓN (opcional)',
    factura_desc_placeholder: 'Ej: Almuerzo',
    factura_registrar_gasto: '💸 Registrar gasto',
    factura_cancelar: '✕ Cancelar',
    factura_monto_invalido: 'Ingresa un monto válido',
    factura_usuario_no_identificado: 'Usuario no identificado',
    factura_selecciona_categoria_error: 'Selecciona una categoría',

    // ── Suggestion Box ──
    sugerencia_tooltip: 'Sugerencias',
    sugerencia_titulo: '💡 Tu sugerencia',
    sugerencia_placeholder: '¿Qué te gustaría que mejoráramos?',
    sugerencia_enviando: 'Enviando...',
    sugerencia_enviar: 'Enviar sugerencia',
    sugerencia_muy_larga_titulo: 'Sugerencia muy larga',
    sugerencia_muy_larga_desc: 'Máximo 500 caracteres',
    sugerencia_no_permitido_titulo: 'No permitido',
    sugerencia_no_permitido_desc: 'Tu sugerencia contiene contenido no permitido',
    sugerencia_gracias_titulo: '¡Gracias!',
    sugerencia_gracias_desc: 'Tu sugerencia fue enviada 🙌',
    sugerencia_error_titulo: 'Error',
    sugerencia_error_desc: 'Hubo un error, intenta de nuevo',

    // ── Home: fecha y mensajes dinámicos ──
    home_fecha_locale: 'es-CO',
    bonzai_msg_1: '👀 Ojo... esa alerta está esperando pacientemente mientras tú ignoras responsabilidades.',
    bonzai_msg_2: "💸 Tu dinero dijo: 'por favor no me hagas pagar mora otra vez'.",
    bonzai_msg_3: '⏰ El tiempo corre... y las facturas también.',
    bonzai_msg_4: 'Esa alerta no se va a pagar sola campeón.',
    bonzai_msg_5: '🚨 Alerta financiera detectada: posible ataque de procrastinación.',
    bonzai_msg_6: '😭 Tu yo del futuro está rogando que pagues todo a tiempo.',
    saving_msg_1: '🫣 Tu yo financiero espera un ahorro aunque sea de 5 mil.',
    saving_msg_2: '💸 Crear una deuda cuenta como organización... técnicamente.',
    saving_msg_3: '😟 Lo que estás soñando no se va a comprar si no ahorras.',
    saving_msg_4: '🐷 El cerdo de la alcancía debe estar como tú, lleno.',
    saving_msg_5: '🚀 Un ahorro pequeño sigue siendo mejor que cero.',
    saving_msg_6: '😎 Las metas financieras también dan desarrollo de personaje.',
    saving_msg_7: '👻 Deja los gastos hormiga, empieza a ahorrar.',
    income_msg_zero_1: '🫣 Tu billetera está esperando su evento canónico.',
    income_msg_zero_2: '👀 Cero ingresos... el silencio antes de la tormenta financiera.',
    income_msg_zero_3: '🌵 Más seco que el desierto, pero todo puede cambiar.',
    income_msg_low_1: '🌱 Todo gran imperio financiero empieza pequeño.',
    income_msg_low_2: '🐣 Apenas estás incubando ese flujo de caja.',
    income_msg_low_3: '🔋 Cargando ingresos... 12% completado.',
    income_msg_mid_1: '💸 Vas construyendo ingresos bastante decentes.',
    income_msg_mid_2: '📈 Esto ya empieza a verse como un plan.',
    income_msg_mid_3: '🙌 Nada mal, sigue así campeón.',
    income_msg_high_1: '🚀 Ese flujo de dinero ya se siente poderoso.',
    income_msg_high_2: '👑 Estás en modo magnate por ahora.',
    income_msg_high_3: '🔥 Ingresos en llamas, en el buen sentido.',
    expense_msg_zero_1: '😎 Increíble... ni un peso gastado por ahora.',
    expense_msg_zero_2: '🧘 Calma total, tu plata no ha sufrido nada.',
    expense_msg_zero_3: '🛡️ Gastos: 0. Eres invencible (por ahora).',
    expense_msg_low_1: '🧠 Tus gastos siguen bastante controlados.',
    expense_msg_low_2: '✅ Disciplina financiera nivel principiante exitoso.',
    expense_msg_low_3: '🧊 Gastos bien fríos, todo bajo control.',
    expense_msg_mid_1: '💸 Se fue algo de dinero... pero todo bajo control.',
    expense_msg_mid_2: '🌀 Los gastos empiezan a moverse, ojo con eso.',
    expense_msg_mid_3: '🧾 Algunas facturas decidieron unirse a la fiesta.',
    expense_msg_high_1: '💀 Tus gastos desbloquearon modo leyenda.',
    expense_msg_high_2: '🔥 Tu billetera está pidiendo auxilio.',
    expense_msg_high_3: '🌪️ Eso ya no es gasto, es huracán categoría 5.',
    Escanear_facturaqr: "📄 Escanear Factura",
    perfil_loading_titulo: 'Perfil',
    perfil_loading_desc: 'Preparando tu espacio personal...',
    suscripcion_header: '💳 Suscripción',
    suscripcion_plan_nombre: 'Calypso Suscripción',
    suscripcion_periodicidad: 'Cobro mensual',
    suscripcion_periodicidad_anual: 'Cobro anual',
    suscripcion_plan_mensual: 'Mensual',
    suscripcion_plan_anual: 'Anual',
    suscripcion_nota_conversion: 'El cobro se procesa en pesos colombianos (COP) al valor de cambio del día.',
    suscripcion_beneficio_1: 'Analíticas avanzadas ilimitadas',
    suscripcion_beneficio_2: 'Escaneo de facturas sin límite',
    suscripcion_beneficio_3: 'Ahorros compartidos ilimitados',
    suscripcion_beneficio_4: 'Soporte prioritario',
    suscripcion_pagar_btn: '💳 Pagar',
    suscripcion_procesando: 'Procesando...',
    suscripcion_error_generico: 'Ocurrió un error al iniciar el pago. Intenta de nuevo.',
    suscripcion_error_widget: 'No se pudo cargar el widget de pago.',
    suscripcion_pago_aprobado: '¡Pago aprobado! Tu suscripción se activará en breve.',
    suscripcion_pago_pendiente: 'Tu pago está pendiente de confirmación.',
    suscripcion_pago_rechazado: 'El pago fue rechazado. Intenta con otro medio.',
    suscripcion_pago_error: 'Hubo un problema con el pago. Intenta de nuevo.',
    suscripcion_nota_seguridad: 'Pagos procesados de forma segura.',
    suscripcion_perfil_titulo: 'Calypso Suscrito!',
    suscripcion_perfil_desc: 'Desbloquea funciones avanzadas',
    suscripcion_activa_badge: 'Activa',
    suscripcion_vence_pre: 'Vence el',
    paywall_trial_titulo: '🎁 Estás en tu prueba gratis',
    paywall_vencido_titulo: '🔒 Tu prueba gratis terminó',
    paywall_trial_desc_pre: 'Te quedan',
    paywall_trial_desc_post: 'Esta función seguirá disponible al terminar si activas tu suscripción.',
    paywall_vencido_desc: 'Activa tu suscripción para seguir usando esta función y todas las herramientas de Calypso.',
    paywall_dia: 'día',
    paywall_dias: 'días',
    paywall_btn: '⭐ Ver suscripción',
    // ── Creadores ──
    creadores_header_titulo: 'Creadores',
    creadores_header_subtitulo: 'El equipo detrás de la app',
    creadores_cerrar_btn: 'Cerrar',
    creadores_apoyar_btn: 'Apoyar',
    creadores_kicker: 'Una historia de código y café',
    creadores_titulo_principal: '🚀 Gracias por usar nuestra app',
    creadores_parrafo_1: 'Esta aplicación nació de una idea simple: hacer que llevar las cuentas sea fácil, bonito y sin complicaciones. Cada pantalla, cada animación, cada detalle fue pensado con cariño para que tú puedas enfocarte en lo que importa.',
    creadores_parrafo_2: 'Detrás de esto hay noches largas, tazas de café frías, bugs que aparecen en el peor momento y la satisfacción enorme de ver funcionar algo que construimos desde cero. No somos una empresa grande ni tenemos inversores. Somos personas reales que le apostaron a esto.',
    creadores_fundadores_titulo: 'Fundadores',
    creadores_dev_titulo: 'Desarrollador & Dev principal',
    creadores_dev_desc: 'Diseño, código, pruebas, despliegue. Un solo cerebro detrás de cada feature. Si algo funciona bien, él lo hizo. Si algo falla... también. 😅',
    creadores_parrafo_3: 'Cada persona que usa la app nos da una razón más para seguir. Pero si quieres ir un paso más allá y apoyar este emprendimiento, cualquier contribución, por pequeña que sea, nos ayuda a pagar servidores, dominio y seguir construyendo.',
    creadores_parrafo_4: 'Gracias de verdad. No de esa forma genérica de "gracias por usar nuestro producto". Gracias de verdad, de persona a persona, por confiar en algo que hicimos con las manos. 💜',
    creadores_footer_texto: 'Hecho con amor · Colombia 🇨🇴 ♥',
    creadores_panel_titulo: '☕ Elige cómo apoyarnos',
    creadores_banco_tipo_cuenta: 'Ahorros',
    creadores_banco_numero_label: 'Número de cuenta',
    creadores_banco_titular_label: 'Titular',
    //Declaracion de Renta
    declaracion_renta_card_titulo: 'Declaración de renta',
    declaracion_renta_card_desc: 'Te ayuda a organizar tus datos para declarar renta en Colombia.',
    declaracion_renta_card_cta: 'CLICK PARA VER 🧾',

    declaracion_header: 'Declaración de Renta',
    declaracion_aviso_colombia: '⚠️ Esta sección aplica únicamente para usuarios en Colombia.',
    declaracion_cedula_pedir: 'Antes de generar tu resumen, necesitamos tu número de cédula.',
    declaracion_cedula_placeholder: 'Número de cédula',
    declaracion_guardar_cedula: 'Guardar cédula',
    declaracion_guardando_cedula: 'Guardando...',
    declaracion_error_guardar_cedula: 'No se pudo guardar la cédula. Intenta de nuevo.',
    declaracion_periodo_titulo: 'Selecciona el periodo a declarar',
    declaracion_generar_btn: 'Generar resumen automático',
    declaracion_generando: 'Generando...',
    declaracion_falta_cedula_nota: 'Guarda tu cédula arriba para poder generar el resumen.',
    declaracion_error_fechas: 'Selecciona el rango de fechas completo.',
    declaracion_error_generar: 'No se pudo generar el resumen. Intenta de nuevo.',
    declaracion_cedula_label: 'Cédula:',
    declaracion_periodo_label: 'Periodo:',
    declaracion_ingresos_label: 'INGRESOS',
    declaracion_gastos_label: 'GASTOS',
    declaracion_neto_label: 'NETO',
    declaracion_ingresos_por_categoria: 'Ingresos por categoría',
    declaracion_gastos_por_categoria: 'Gastos por categoría',
    declaracion_sin_ingresos_periodo: 'Sin ingresos en el periodo',
    declaracion_sin_gastos_periodo: 'Sin gastos en el periodo',
    declaracion_imprimir_btn: '🖨️ Imprimir / Guardar como PDF',
    declaracion_cargando: 'Cargando...',
    declaracion_neto_nota: '(no es tu renta líquida gravable)',
    declaracion_topes_titulo: '📌 ¿Debo declarar? Topes de referencia (año gravable 2025)',
    declaracion_topes_texto: 'Debes declarar si en 2025 superaste al menos uno: patrimonio bruto mayor a 4.500 UVT ($224.096.000), ingresos brutos iguales o mayores a 1.400 UVT ($69.719.000), consumos con tarjeta de crédito, compras o consignaciones bancarias por más de 1.400 UVT, o si fuiste responsable de IVA. Esto es solo referencia, verifica tu caso con la DIAN o un contador.',
    declaracion_disclaimer: 'Este resumen es una herramienta de apoyo generada por Calypso en versión beta. No es un documento oficial de la DIAN, no tiene validez tributaria ni puede presentarse como declaración de renta. Los cálculos y clasificaciones son orientativos: valida siempre la información con un contador o directamente en el portal MUISCA antes de declarar.',
    forgot_password_title: '¿Olvidaste tu contraseña?',
    forgot_password_desc: 'Ingresa tu correo y te enviaremos un enlace para crear una nueva contraseña.',
    forgot_password_email_label: 'Correo electrónico',
    forgot_password_email_placeholder: 'tucorreo@ejemplo.com',
    forgot_password_error_required: 'El correo es requerido',
    forgot_password_error_invalid: 'Correo no válido',
    forgot_password_error_rate_limit: 'Demasiados intentos. Espera unos minutos e intenta de nuevo.',
    forgot_password_sending: 'Enviando...',
    forgot_password_send_btn: 'Enviar enlace →',
    forgot_password_back_login: '← Volver al inicio de sesión',
    forgot_password_sent_title: 'Revisa tu correo',
    forgot_password_sent_desc: 'Si {email} está registrado, recibirás un enlace para restablecer tu contraseña.',
    forgot_password_sent_expire: 'Haz clic en el enlace del correo y podrás ingresar una nueva contraseña. El enlace expira en {time}.',
    forgot_password_expire_time: '1 hora',
    forgot_password_no_email: '¿No llegó el correo? Revisa tu carpeta de spam o',
    forgot_password_try_another: 'intenta con otro correo',
    login_error_email_required: 'El correo es requerido',
    login_error_email_invalid: 'Correo no válido',
    login_error_password_required: 'La contraseña es requerida',
    login_error_invalid_credentials: 'Correo o contraseña incorrectos.',
    login_error_email_not_confirmed: 'Debes confirmar tu correo antes de ingresar.',
    login_error_generic: 'Ocurrió un error. Intenta de nuevo.',
    login_title: 'Bienvenido de vuelta',
    login_subtitle: 'Ingresa a tu cuenta para continuar',
    login_email_label: 'Correo electrónico',
    login_email_placeholder: 'tucorreo@ejemplo.com',
    login_password_label: 'Contraseña',
    login_password_placeholder: 'Tu contraseña',
    login_forgot_password: '¿Olvidaste tu contraseña?',
    login_loading: 'Ingresando...',
    login_submit: 'Ingresar →',
    login_no_account: '¿No tienes cuenta?',
    login_register_link: 'Regístrate gratis',

    unlock_ahora_no: 'Ahora no',
    actualizacion_nunca: 'aún no actualizado',
    actualizacion_menos_1_min: 'hace menos de 1 minuto',
    actualizacion_minutos: 'hace {n} minutos',
    actualizacion_horas: 'hace {n} horas',
    suscripcion_trial_activa: 'Prueba gratis · vence en',
    suscripcion_trial_vencida: 'Tu prueba gratis terminó · suscríbete para seguir usando Calypso',
    dia_singular: 'día',
    dias_plural: 'días',
    recargar_sesiones: 'Recargar',

    modal_cerrar_sesiones_titulo: '¿Cerrar todas las sesiones excepto esta?',
    modal_cerrar_sesiones_desc: 'Tendrás que volver a iniciar sesión en tus otros dispositivos.',
    modal_cerrar_sesiones_confirmar: 'Sí, cerrar sesiones',
    modal_cancelar: 'Cancelar',
    modal_generar_id_titulo_ya: '⚠️ Ya tienes un ID generado',
    modal_generar_id_titulo_nuevo: 'Generar ID de amigo',
    modal_generar_id_desc_ya: 'Esto reemplazará tu ID actual. El anterior dejará de funcionar.',
    modal_generar_id_desc_nuevo: 'Esta acción generará un ID único para que otros puedan agregarte como amigo.',
    modal_generar_id_confirmar_ya: 'Sí, reemplazar',
    modal_generar_id_confirmar_nuevo: 'Sí, generar',
    //I.A
    ia_analizando: 'Analizando tus finanzas',
    ia_bienvenida: '¡Hola {name}! 👋 Soy tu asistente financiero personal.\n\nYa cargué tu información financiera de los últimos 3 meses. Puedo ayudarte a entender tus patrones de gasto, evaluar tus metas de ahorro y darte consejos personalizados basados en tus datos reales.\n\n¿Qué quieres saber hoy? 💡',
    ia_error_procesar: '⚠️ Hubo un problema al procesar tu consulta. Por favor intenta de nuevo en unos segundos.',
    ia_sin_conexion_titulo: 'Sin conexión a internet',
    ia_sin_conexion_desc: 'Necesitas estar conectado a internet para hablar con tu asistente financiero.',
    ia_volver_inicio: 'Volver al inicio',
    ia_preparando_titulo: 'Preparando tu asistente',
    ia_preparando_desc: 'Cargando tu información financiera...',
    ia_header_titulo: 'Asistente Financiero',
    ia_header_estado: '● Activo · Solo responde sobre tus finanzas',
    ia_datos_listos: '✓ Datos listos',
    ia_ultimos_3_meses: 'Últimos 3 meses',
    ia_privacidad_chip: '🔒 Tus datos son privados y no se almacenan en el chat',
    ia_preguntas_sugeridas: 'Preguntas sugeridas',
    ia_input_placeholder: 'Pregunta sobre tus finanzas...',
    ia_footer_hint: 'Solo responde preguntas sobre tus finanzas personales · Enter para enviar',
    ia_sugerencia_1: '¿Cómo van mis finanzas este mes?',
    ia_sugerencia_2: '¿En qué estoy gastando más?',
    ia_sugerencia_3: '¿Puedo permitirme ahorrar más?',
    ia_sugerencia_4: '¿Cómo voy con mis metas de ahorro?',
    ia_sugerencia_5: 'Dame un consejo para reducir gastos',
    ia_sugerencia_6: '¿Cuál es mi balance general?',
    //FacturaEscaner
    factura_sin_internet_error: 'Necesitas conexión a internet para escanear la factura.',
    factura_error_procesar_imagen: 'Error al procesar imagen:',
    factura_error_guardar: 'Error al guardar:',
    factura_fuente_qr: 'Datos del QR',
    factura_fuente_vision: 'Claude Vision',
    factura_fuente_manual: 'Manual',
    factura_sin_logs: 'Sin logs aún...',
    factura_aria_escanear: 'Escanear factura',
    factura_menu_sin_internet: 'Sin conexión. Podrás ingresar los datos manualmente cuando vuelvas a tener internet.',
    factura_guia_titulo: '¿Cómo tomar la foto?',
    factura_guia_tip_internet: 'Necesitas conexión a internet para analizar la factura.',
    factura_guia_tip_1: 'Enfoca donde dice "TOTAL A PAGAR" o "VALOR TOTAL"',
    factura_guia_tip_2: 'Asegúrate de que el texto esté nítido y bien iluminado',
    factura_guia_tip_3: 'No fotografíes solo el código QR — no contiene el valor',
    factura_guia_boton_foto: 'Tomar foto',
    factura_analizando_titulo: 'Analizando factura...',
    factura_analizando_desc: 'Leyendo factura con Claude Vision...',
    factura_guardando_titulo: 'Guardando gasto...',
    factura_exito_titulo: '¡Gasto registrado!',
    factura_exito_fuente: 'Fuente:',
    //Eliminación de cuenta
    eliminar_cuenta_boton: 'Eliminar mi cuenta',
    eliminar_cuenta_titulo: 'Eliminar cuenta de Calypso',
    eliminar_cuenta_intro: 'Esta página te permite solicitar la eliminación permanente de tu cuenta y datos asociados en Calypso (Bonzzai Enterprise), en cumplimiento con las políticas de Google Play sobre eliminación de cuentas.',
    eliminar_cuenta_que_titulo: '¿Qué se elimina?',
    eliminar_cuenta_item1: 'Tu perfil (nombre, foto, correo)',
    eliminar_cuenta_item2: 'Ingresos, gastos y datos financieros registrados',
    eliminar_cuenta_item3: 'Ahorros compartidos, alertas, mensajes y sesiones activas',
    eliminar_cuenta_item4: 'Tu cuenta de autenticación',
    eliminar_cuenta_aviso: 'Esta acción es irreversible. Los registros de facturación gestionados por Google Play/RevenueCat se conservan hasta 90 días adicionales por requisitos contables y de prevención de fraude.',
    eliminar_cuenta_login_req: 'Para eliminar tu cuenta, inicia sesión primero.',
    eliminar_cuenta_login_btn: 'Iniciar sesión',
    eliminar_cuenta_continuar: 'Continuar con la eliminación',
    eliminar_cuenta_confirmar_texto: 'Escribe ELIMINAR para confirmar que quieres borrar la cuenta de',
    eliminar_cuenta_confirmar_btn: 'Eliminar cuenta permanentemente',
    eliminar_cuenta_eliminando: 'Eliminando...',
    eliminar_cuenta_exito: 'Tu cuenta fue eliminada',
    eliminar_cuenta_error: 'No se pudo eliminar la cuenta',
    eliminar_cuenta_error_desc: 'Intenta de nuevo o escríbenos.',
    eliminar_cuenta_confirm_warning: 'Escribe ELIMINAR para confirmar',
    eliminar_cuenta_palabra_confirmacion: 'ELIMINAR',
    eliminar_datos_titulo: 'Eliminar datos en Calypso',
    eliminar_datos_intro: 'Calypso (Bonzzai Enterprise) te permite eliminar datos específicos de tu cuenta sin necesidad de borrar toda la cuenta. A continuación se detallan los pasos para cada tipo de dato.',
    eliminar_datos_transacciones_titulo: 'Transacciones (ingresos y gastos)',
    eliminar_datos_transacciones_desc: 'Ingresa a la app → Ingresos o Gastos → mantén presionado o desliza sobre el registro → toca "Eliminar". El dato se borra de inmediato de nuestra base de datos.',
    eliminar_datos_foto_titulo: 'Foto de perfil',
    eliminar_datos_foto_desc: 'Ingresa a Perfil → mantén el cursor sobre tu foto → toca el ícono de basura. La imagen se elimina de inmediato de nuestro almacenamiento.',
    eliminar_datos_sugerencias_titulo: 'Sugerencias enviadas a la comunidad',
    eliminar_datos_sugerencias_desc: 'Ingresa a la sección de Sugerencias → localiza tu sugerencia → toca "Eliminar". Se borra de inmediato y deja de ser visible para otros usuarios.',
    eliminar_datos_conservados: 'Datos que se conservan:',
    eliminar_datos_conservados_desc: 'los registros de facturación gestionados por Google Play/RevenueCat se conservan hasta 90 días adicionales por requisitos contables y de prevención de fraude.',
    eliminar_datos_pregunta_cuenta: '¿Quieres eliminar toda tu cuenta en lugar de datos individuales?',
    eliminar_datos_link_cuenta: 'Ve aquí',
    //YA ESTAS SUCRITO  
    suscripcion_ya_suscrito_titulo: 'Ya estás suscrito',
    suscripcion_activa_sin_fecha: 'Tu suscripción está activa.',
    suscripcion_gestionar_playstore: 'Gestionar suscripción en Google Play',
    suscripcion_gestionar_soporte: 'Contactar soporte para gestionar mi suscripción',
    //DECLARACION RENTA
    declaracion_ingresos_por_cedula: 'Ingresos por cédula fiscal',
    declaracion_revisar_manual_titulo: 'Revisar manualmente',
    declaracion_revisar_manual_desc: 'Estos ingresos no se pudieron clasificar automáticamente. Verifica a qué cédula pertenecen antes de declarar.',
    declaracion_cedula_trabajo: 'Rentas de trabajo',
    declaracion_cedula_capital: 'Rentas de capital',
    declaracion_cedula_no_laboral: 'Rentas no laborales',
    declaracion_cedula_pensiones: 'Rentas de pensiones',
    declaracion_cedula_dividendos: 'Dividendos y participaciones',
    declaracion_cedula_ganancia_ocasional: 'Ganancias ocasionales',
    declaracion_cedula_no_clasificado: 'Sin clasificar',
    declaracion_badge_beta: 'Beta',
    declaracion_descargar_btn: 'Descargar resumen',
    declaracion_confirmar_descarga: 'Este resumen es de referencia y no reemplaza tu declaración oficial ante la DIAN. ¿Deseas continuar?',
    declaracion_requiere_suscripcion_titulo: 'Función exclusiva para suscriptores',
    declaracion_requiere_suscripcion_desc: 'La declaración de renta está disponible solo para usuarios con suscripción activa (no incluida en la prueba gratis).',
    declaracion_datos_adicionales_titulo: 'Datos adicionales para tu declaración',
    declaracion_datos_adicionales_desc: 'Estos datos no se calculan desde tus transacciones. Complétalos manualmente para tener un resumen más cercano a tu declaración real.',
    declaracion_campo_patrimonio_bruto: 'Patrimonio bruto (total de tus bienes)',
    declaracion_campo_deudas: 'Deudas',
    declaracion_campo_retenciones: 'Retenciones en la fuente practicadas',
    declaracion_campo_aportes_pension: 'Aportes voluntarios a pensión',
    declaracion_campo_aportes_afc: 'Aportes a cuentas AFC',
    declaracion_campo_intereses_vivienda: 'Intereses de crédito de vivienda',
    declaracion_campo_medicina_prepagada: 'Medicina prepagada',
    declaracion_campo_dependientes: 'Número de dependientes económicos',
    declaracion_error_cargar_datos_fiscales: 'No se pudieron cargar tus datos fiscales.',
    declaracion_error_guardar_datos_fiscales: 'No se pudieron guardar tus datos fiscales.',
    declaracion_datos_guardados_ok: 'Datos guardados correctamente.',
    declaracion_guardando: 'Guardando...',
    declaracion_guardar_datos: 'Guardar datos',
    declaracion_confirmar_descarga_titulo: 'Antes de continuar',
    declaracion_confirmar_descarga_btn: 'Sí, descargar',
    declaracion_error_pdf: 'No pudimos generar el PDF. Intenta de nuevo.',
    declaracion_generando_pdf: 'Generando PDF...',
    // ── Plantillas rápidas: compartidas ──
    pl_boton: 'Rápidos',
    pl_nueva: 'Nueva plantilla',
    pl_editar: 'Editar plantilla',
    pl_agregar: 'Agregar',
    pl_agregado_ok: 'Agregado',
    pl_nota_fecha: 'Se agregan con la fecha de hoy',
    pl_err_monto: 'El monto debe ser mayor a 0',
    pl_err_categoria: 'Selecciona o escribe una categoría',
    pl_err_categoria_larga: 'La categoría no puede tener más de 50 caracteres',
    pl_err_desc_larga: 'La descripción no puede tener más de 200 caracteres',
    pl_err_guardar: 'No se pudo guardar la plantilla',
    pl_err_agregar: 'No se pudieron agregar los registros. Intenta de nuevo.',
    // ── Plantillas rápidas: ingresos ──
    pl_titulo_ingreso: 'Ingresos rápidos',
    pl_desc_ingreso: 'Tus ingresos fijos, listos para agregar con un clic',
    pl_vacio_ingreso: 'Aún no tienes ingresos fijos. Crea uno, por ejemplo tu salario.',
    // ── Plantillas rápidas: gastos ──
    pl_titulo_gasto: 'Gastos rápidos',
    pl_desc_gasto: 'Tus gastos fijos, listos para agregar con un clic',
    pl_vacio_gasto: 'Aún no tienes gastos fijos. Crea uno, por ejemplo tu arriendo.',
    // ── Tutorial ──
    tour_siguiente: 'Siguiente',
    tour_anterior: 'Atrás',
    tour_listo: '¡Listo!',
    tour_ayuda: 'Tutoriales',
    tour_ayuda_desc: 'Elige una sección y te guiamos paso a paso',
    tour_menu_ingresos: 'Tutorial de Ingresos',
    tour_menu_gastos: 'Tutorial de Gastos',
    // Compartidos
    tour_mes_t: 'Cambia de mes',
    tour_mes_d: 'Elige otro mes para ver y registrar movimientos de ese periodo.',
    tour_import_t: 'Importa tu extracto con IA',
    tour_import_d: 'Sube el archivo de tu banco (CSV, TXT, XML o PDF) y la IA detecta los movimientos por ti. Toca Siguiente para ver cómo.',
    tour_pais_t: 'Elige tu país y sube el archivo',
    tour_pais_d: 'Selecciona tu país para que la IA entienda el formato de fechas y moneda, y luego sube el extracto. Podrás revisar y editar todo antes de importar.',
    tour_plantillas_t: 'Registros rápidos',
    tour_filtro_t: 'Filtra por categoría',
    tour_filtro_d: 'Muestra solo los movimientos de una categoría o busca una personalizada.',
    // Ingresos
    tour_ing_total_t: 'Tus ingresos del mes',
    tour_ing_total_d: 'Aquí ves cuánto has recibido en el mes seleccionado. Toca la gráfica para ir a Analíticas.',
    tour_ing_form_t: 'Registra un ingreso',
    tour_ing_form_d: 'Escribe el monto, elige la fecha y la categoría, agrega una descripción si quieres y toca "Agregar ingreso".',
    tour_ing_lista_t: 'Tus ingresos',
    tour_ing_lista_d: 'Aquí aparecen los ingresos del mes. Con ✏️ cambias el monto y con 🗑️ eliminas el registro.',
    // Gastos
    tour_gas_total_t: 'Tus gastos del mes',
    tour_gas_total_d: 'Aquí ves cuánto has gastado en el mes seleccionado. Toca la gráfica para ir a Analíticas.',
    tour_gas_form_t: 'Registra un gasto',
    tour_gas_form_d: 'Escribe el monto, elige la fecha y la categoría, agrega una descripción si quieres y toca "Agregar gasto".',
    tour_gas_lista_t: 'Tus gastos',
    tour_gas_lista_d: 'Aquí aparecen los gastos del mes. Con ✏️ cambias el monto y con 🗑️ eliminas el registro.',
    tour_plantillas_d: 'Aquí guardas tus movimientos fijos, como el salario o el arriendo. Toca Siguiente y lo abrimos por ti.',
    tour_pl_nueva_t: 'Crea una plantilla',
    tour_pl_nueva_d: 'Con este botón creas un movimiento fijo. Ahora te mostramos el formulario.',
    tour_pl_form_t: 'Llena tu plantilla',
    tour_pl_form_d: 'Pruébalo: escribe el monto, elige la categoría y, si quieres, una descripción (por ejemplo "Salario"). Si la guardas, quedará como tu primera plantilla. O toca Siguiente para continuar sin guardar.',
    tour_pl_lista_t: 'Tus plantillas',
    tour_pl_lista_d: 'Aquí aparecen las que creaste. Marca o desmarca las que quieras agregar, y usa ✏️ para editarlas o 🗑️ para eliminarlas.',
    tour_pl_agregar_t: 'Agrégalas con un clic',
    tour_pl_agregar_d: 'Este botón agrega al instante todas las plantillas marcadas, con la fecha de hoy y sin escribir nada.',
    tour_menu_home: 'Tutorial del Inicio',
    tour_menu_ahorro: 'Tutorial de Ahorros y Deudas',
    // Home
    tour_home_bienvenida_t: '¡Bienvenido a Calypso!',
    tour_home_bienvenida_d: 'Te hacemos un recorrido rápido por el inicio. Toca Siguiente para empezar.',
    tour_home_periodo_t: 'Elige tu período',
    tour_home_periodo_d: 'Mira tus números por mes o cambia a la vista general para ver todo tu historial.',
    tour_home_ingresos_t: 'Tus ingresos',
    tour_home_ingresos_d: 'Cuánto has recibido en el período. Toca la tarjeta para ir a registrar un ingreso.',
    tour_home_gastos_t: 'Tus gastos',
    tour_home_gastos_d: 'Cuánto has gastado en el período. Toca la tarjeta para ir a registrar un gasto.',
    tour_home_balance_t: 'Tu balance',
    tour_home_balance_d: 'Ingresos menos gastos. Toca la tarjeta para ver tus analíticas.',
    tour_home_ahorro_t: 'Ahorros y deudas',
    tour_home_ahorro_d: 'Aquí rota tu ahorro o deuda destacada con su progreso. Toca la tarjeta para administrarlos.',
    tour_home_renta_t: 'Declaración de renta',
    tour_home_renta_d: 'Organiza tus datos para declarar renta en Colombia.',
    tour_home_herr_t: 'Herramientas rápidas',
    tour_home_herr_d: 'Escanea una factura, envía una sugerencia o mira el muro de sugerencias de la comunidad.',
    tour_home_extras_t: 'Más opciones',
    tour_home_extras_d: 'Esta flecha despliega la barra con tus notificaciones y alertas. Toca Siguiente y la abrimos por ti.',
    tour_home_notif_t: 'Notificaciones',
    tour_home_notif_d: 'La campana te avisa de solicitudes de amigos, ahorros compartidos, mensajes y zumbidos. El número rojo son las que no has leído.',
    tour_home_panel_t: 'Tu bandeja',
    tour_home_panel_d: 'Aquí aparecen tus notificaciones. Puedes aceptar o rechazar solicitudes, marcar todo como leído o borrar una con ✕.',
    tour_home_alertas_t: 'Alertas',
    tour_home_alertas_d: 'Tus recordatorios de pagos con fecha límite y mora. Se sacude cuando tienes alertas pendientes.',
    tour_home_perfil_t: 'Tu perfil',
    tour_home_perfil_d: 'Tu foto o inicial te lleva al perfil: idioma, colores, moneda, temas y sesiones.',
    tour_home_nav_t: 'Navegación',
    tour_home_nav_d: 'Desde aquí vas al calendario, amigos, mensajes y el asistente de I.A.',
    // Ahorros
    tour_aho_resumen_t: 'Tu resumen',
    tour_aho_resumen_d: 'Disponible es el dinero libre de tu balance y Total ahorrado es lo que tienes guardado en tus ahorros.',
    tour_aho_nuevo_t: 'Crea un ahorro o deuda',
    tour_aho_nuevo_d: 'Con este botón creas uno nuevo. Toca Siguiente y te mostramos el formulario (no se guarda nada).',
    tour_aho_tipo_t: 'Ahorro o deuda',
    tour_aho_tipo_d: 'Elige si es una meta de ahorro o una deuda que quieres ir pagando.',
    tour_aho_datos_t: 'Los datos',
    tour_aho_datos_d: 'Ponle un nombre, una descripción opcional y una meta en pesos opcional para ver tu progreso.',
    tour_aho_compartir_t: 'Compártelo con un amigo',
    tour_aho_compartir_d: 'Activa esta opción para ahorrar junto a un amigo, o para que vea cómo le pagas una deuda. Tu amigo debe aceptar la invitación.',
    tour_aho_personales_t: 'Tus ahorros personales',
    tour_aho_personales_d: 'Cada tarjeta muestra lo acumulado, la meta y el progreso. Toca una para meter o sacar dinero. Te mostramos cómo.',
    tour_aho_mov_monto_t: 'Escribe el monto',
    tour_aho_mov_monto_d: 'Ingresa cuánto vas a meter o sacar. Meter descuenta de tu disponible y sacar lo devuelve.',
    tour_aho_mov_comprobante_t: 'Comprobante',
    tour_aho_mov_comprobante_d: 'Si quieres, adjunta una foto del comprobante. En los ahorros compartidos es obligatorio.',
    tour_aho_mov_acciones_t: 'Acciones',
    tour_aho_mov_acciones_d: 'Mete o saca dinero, o elimina el ahorro (lo acumulado vuelve a tu balance).',
    tour_aho_compartidos_t: 'Ahorros compartidos',
    tour_aho_compartidos_d: 'Aquí ves lo que ahorras con amigos: el aporte de cada uno, el progreso y el botón 📳 Zumbido para recordarle a tu amigo. Los completados se guardan en 🎉 y las deudas compartidas son de solo lectura para quien no las creó.',
    tour_aho_vacio_t: 'Aún no tienes ahorros',
    tour_aho_vacio_d: 'Cuando crees tu primer ahorro o deuda aparecerá aquí. Vuelve a abrir este tutorial y te mostramos cómo manejarlos.',
  //NUEVOS TEMAS
      saludo_halloween: '🎃 ¡Feliz Halloween,',
    saludo_navidad: '🎄 ¡Feliz Navidad,',
    saludo_colombia: '☕ ¡Quiubo,',
    saludo_cerveza: '🍺 ¡Salud,',
    cargando_halloween: 'Despertando a los fantasmas...',
    cargando_navidad: 'Colgando las luces...',
    cargando_colombia: 'Colando el tinto...',
    cargando_cerveza: 'Sirviendo la espuma...',
    tema_worldcup_nombre: 'Mundial 2026',
    tema_worldcup_desc: 'Estadios, fútbol, trofeos y ambiente mundialista.',
    tema_halloween_nombre: 'Halloween',
    tema_halloween_desc: 'Calabazas, fantasmas y noches de terror.',
    tema_navidad_nombre: 'Navidad',
    tema_navidad_desc: 'Nieve, luces y espíritu navideño.',
    tema_colombia_nombre: 'Colombia',
    tema_colombia_desc: 'Café, montañas y los colores de la bandera.',
    tema_cerveza_nombre: 'Cerveza',
    tema_cerveza_desc: 'Espuma, brindis y buena rumba.',
    tema_badge_desbloqueado: '¡Tema desbloqueado!',
    tema_aplicar: '✨ Aplicar tema',
    tema_toast_desbloqueado: 'Tema desbloqueado',
    tema_toast_desbloqueado_desc: '{tema} ya está disponible en tu perfil.',
  },

  en: {
    // ── Perfil ──
    perfil_titulo: 'My Profile',
    perfil_subtitulo: 'User settings',
    cambiar_foto: '📷 Change photo',
    idioma_titulo: '🌐 Language',
    idioma_desc: 'Choose the language you want to see the app in.',
    canjear_codigo: 'Redeem code',
    canjear_placeholder: '🎁 Enter your code',
    canjear_validando: 'Validating...',
    canjear_boton: 'Redeem code',
    id_amigo_titulo: '🆔 Friend ID',
    id_amigo_desc: 'This ID will be used so other users can add you as a friend.',
    no_generado: 'Not generated',
    regenerar: '🔄 Regenerate',
    generar: '⚡ Generate',
    correo_titulo: '📧 Email',
    correo_desc: 'If you change your email, you will receive a confirmation message.',
    editar: '✏️ Edit',
    bloquear: '🔒 Lock',
    nombre_titulo: '✏️ Display name',
    nombre_desc: 'This is the name other users will see in the app.',
    nombre_placeholder: 'Your display name',
    vista_titulo: '👁️ Preferred view',
    vista_desc_pre: 'Saves which money view you prefer when entering home, either',
    vista_mensual: 'monthly',
    vista_general: 'overall',
    vista_general_activa: '🌎 Overall view enabled',
    vista_mensual_activa: '📅 Monthly view enabled',
    color_titulo: '🎨 App color',
    color_desc: 'Choose the visual palette for the whole app.',
    activo: '✓ Active',
    toca_aplicar: 'Click to apply',
    temas_titulo: '🎭 Themes',
    temas_desc: 'Completely change the look of the app.',
    sin_temas: "You haven't unlocked any theme yet. Redeem a code to unlock one 🎁",
    moneda_titulo: '💱 App currency',
    moneda_desc: 'Choose the currency used to display prices across the app.',
    moneda_aviso: '⚠️ Stored amounts may vary if you change currency. Historical values will be recalculated using the current exchange rate, so small differences may appear. We recommend using a single currency and avoiding changes unless truly necessary. Note: the conversion rate updates every 6 hours. Keep this in mind before converting, as the displayed value may differ slightly from the one applied in future updates.',
    sesiones_titulo: '🔐 Active sessions',
    sesiones_desc: "Devices where you have an open session. Close the ones you don't recognize.",
    cargando_sesiones: 'Loading sessions...',
    sin_sesiones: 'No sessions found',
    esta_sesion: 'This session',
    cerrar: 'Close',
    cerrar_otras_sesiones: '🔒 Close all other sessions',
    ultimo_acceso: 'Last seen',
    tiempo_ahora: 'Just now',
    tiempo_min: '{n} min ago',
    tiempo_hora: '{n}h ago',
    tiempo_dia: '{n}d ago',
    password_titulo: '🔑 Change password',
    password_desc_pre: 'We will send an email to',
    password_desc_post: 'with a link to change your password.',
    enviar_enlace: '📧 Send change link',
    creadores: 'Creators',
    guardar: '💾 Save changes',
    guardando: 'Saving changes...',

    // ── Home ──
    proximamente: 'Coming soon',
    modo_negocio: 'Mode 🏪 Business',
    modo_personal: 'Mode 👤 Personal',
    amigos: 'Friends',
    notificaciones: 'Notifications',
    marcar_todo_leido: 'Mark all as read',
    sin_notificaciones: "You don't have notifications",
    aceptar: '✅ Accept',
    rechazar: '❌ Decline',
    aceptar_eliminar: '🗑️ Accept and delete',
    rechazar_simple: '✕ Decline',
    ver_ahorro_responder: '📳 View savings and reply',
    alertas: 'Alerts',
    cerrar_sesion: 'Log out',
    saludo_mundial: '🏆 Welcome,',
    saludo_normal: 'Hi,',
    bonzai_bot: 'BONZAI BOT 💬',
    alertas_pendientes_pre: '🚨 You have',
    alertas_pendientes_post: 'pending alert(s)',
    ahora_mismo: 'just now',
    muro_sugerencias: 'View suggestions wall',
    periodo_titulo: '📅 Choose the financial period you want!',
    periodo_desc: 'Filter your stats by month or view everything',
    vista_general_btn: '🌎 Overall view',
    vista_mensual_btn: '📅 Monthly view',
    resumen: 'Summary',
    ingresos_totales: 'TOTAL INCOME',
    ingresos_del_mes: 'INCOME THIS MONTH',
    gastos_totales: 'TOTAL EXPENSES',
    gastos_del_mes: 'EXPENSES THIS MONTH',
    tap_registrar_ingreso: 'CLICK TO LOG 💵',
    tap_registrar_gasto: 'CLICK TO LOG 🧾',
    balance_general: 'OVERALL BALANCE',
    balance_positivo: "You're doing well. Your income is winning the fight.",
    balance_negativo: 'Your expenses are speedrunning your money.',
    balance_neutro: 'Perfectly balanced... like a zen wallet.',
    tap_ver_analisis: 'CLICK TO VIEW ANALYTICS 📊',
    elemento_destacado: '🐷 FEATURED ITEM',
    meta: 'Goal:',
    restante: 'Remaining:',
    tap_ver_deudas: 'CLICK TO VIEW DEBTS ',
    tap_ver_ahorros: 'CLICK TO VIEW SAVINGS ',
    compartido: '👥 Shared',
    tap_crear_ahorro: 'CLICK TO CREATE A SAVING 🐷',
    nav_calendario: 'Calendar',
    nav_amigos: 'Friends',
    nav_mensajes: 'Messages',
    nav_ia: 'AI',
    cargando_mundial: 'Setting up the match...',
    cargando_normal: 'Loading your information...',

    //Ingresos
    ingresos_header: '💵 Income',
    volver: '← Back',
    total_ingresos: 'Total income',
    monto_placeholder: 'Amount',
    selecciona_categoria: 'Select a category',
    cat_principales: '💼 Main income',
    cat_salario: 'Salary',
    cat_honorarios: 'Fees',
    cat_negocio_propio: 'Own business',
    cat_adicionales: '✨ Additional income',
    cat_horas_extra: 'Overtime',
    cat_comisiones: 'Commissions',
    cat_bonificaciones: 'Bonuses',
    cat_ocasionales: '🎁 Occasional income',
    cat_primas: 'Bonus pay',
    cat_cesantias: 'Severance fund',
    cat_regalos: 'Gifts or family support',
    cat_personalizado: '➕ Custom',
    cat_otro: 'Other',
    titulo_categoria_placeholder: 'Title of your category',
    descripcion_placeholder: 'Description',
    agregar_ingreso: 'Add income',
    csv_pregunta: 'Already have a CSV?',
    csv_respuesta: 'The app will read it automatically!',
    csv_elige_banco: 'Choose your bank and upload the file',
    csv_importar_titulo: 'Import CSV',
    selecciona_pais: 'SELECT YOUR COUNTRY',
    selecciona_banco: 'SELECT YOUR BANK',
    cambiar_pais: 'Change country',
    cargar_csv_de: 'Upload CSV from',
    selecciona_banco_primero: 'Select a bank first',
    primero_selecciona_banco: 'First select a bank',
    cerrar_modal: 'Close',
    ingresos_detectados: 'Income detected',
    revisa_antes_importar: 'Review before importing. Only credits/income are included.',
    sin_descripcion: 'No description',
    importando: 'Importing...',
    importar_n_ingresos: 'Import',
    cancelar: 'Cancel',
    filtrar_categoria: '🔍 Filter by category',
    todas_categorias: 'All categories',
    buscar_cat_personalizada: 'Search custom category...',
    escribir_nombre_cat: 'Type the category name...',
    resultado: 'result',
    resultados: 'results',
    para_texto: 'for',
    en_texto: 'in',
    limpiar_filtro: '✕ Clear filter',
    sin_ingresos_categoria: 'No income with this category in the selected period.',
    sin_ingresos: 'No income recorded',
    sin_categoria: 'No category',
    guardar_edicion: '✔ Save',
    cancelar_edicion: '✖ Cancel',
    eliminar_registro_titulo: 'Delete this record?',
    eliminar_registro_desc: 'This action cannot be undone.',
    si_eliminar: 'Yes, delete',

    //Gastos
    gastos_header: '💸 Expenses',
    total_gastos: 'Total expenses',
    agregar_gasto: 'Add expense',
    cat_fijos: '🏠 Fixed expenses',
    cat_arriendo: 'Rent',
    cat_administracion: 'HOA fees',
    cat_servicios: '⚡ Utilities',
    cat_agua: 'Water',
    cat_luz: 'Electricity',
    cat_gas: 'Gas',
    cat_internet: 'Internet',
    cat_basicos: '🍽️ Basic expenses',
    cat_mercado: 'Groceries',
    cat_alimentacion: 'Food',
    cat_transporte: 'Transportation',
    cat_deudas: '💳 Debts and obligations',
    cat_tarjetas: 'Credit cards',
    cat_creditos: 'Loans',
    cat_salud: '🏥 Health and protection',
    cat_eps: 'Health insurance',
    cat_medicina_prepagada: 'Prepaid healthcare',
    cat_personales: '📱 Personal expenses',
    cat_celular: 'Phone',
    cat_streaming: 'Streaming (Netflix, Spotify, etc.)',
    cat_ropa: 'Clothing',
    cat_ocio: '🎉 Leisure and lifestyle',
    cat_salidas: 'Outings (restaurants, movies, going out)',
    cat_viajes: 'Travel',
    csv_pregunta_gastos: 'Already have a CSV?',
    csv_respuesta_gastos: 'The app will import your expenses automatically!',
    gastos_detectados: 'Expenses detected',
    revisa_antes_importar_gastos: 'Review before importing. Only debits/expenses are included.',
    sin_gastos_categoria: 'No expenses with this category in the selected period.',
    sin_gastos: 'No expenses recorded',
    importar_n_gastos: 'Import',
    no_se_encontraron_gastos: 'No valid expenses were found. Verify the file belongs to',

    //Ahorros — header / general
    ahorros_header: '💰 Savings / Debts',
    ahorros_disponible: '💵 Available',
    ahorros_total_ahorrado: '🐷 Total saved',
    ahorros_nuevo_btn: '➕ New saving or debt',
    ahorros_loading_title: 'Savings & Debts',
    ahorros_loading_desc: 'Preparing your transactions...',

    //Ahorros — secciones
    ahorros_personales: '👤 Personal',
    ahorros_compartidos: '👥 Shared',
    ahorros_sin_compartidos: 'No shared savings yet',
    ahorros_sin_ahorros_titulo: 'No savings yet',
    ahorros_sin_ahorros_desc: 'Create your first saving or debt above',

    //Ahorros — tipo
    ahorro_tipo_deuda: '🔴 Debt',
    ahorro_tipo_ahorro: '🟠 Saving',
    ahorro_tipo_seguimiento_deuda: '🔴 Debt tracking',
    ahorro_tipo_ahorro_compartido: '🟠 Shared saving',

    //Ahorros — compartidos / estados
    ahorro_pendiente: '⏳ Pending',
    ahorro_activo: '✅ Active',
    ahorro_compartido_badge: '👥 Shared',
    ahorro_zumbido_btn: '📳 Buzz',
    ahorro_zumbido_title: 'Send a buzz to',
    ahorro_con: 'With',
    ahorro_de: 'From',
    ahorro_solo_lectura: '👁 Read only',
    ahorro_total_pagado: '💰 Total paid',
    ahorro_tu_aporte: 'Your contribution',
    ahorro_su_aporte: 'Their contribution',
    ahorro_esperando_acepte_pre: 'Waiting for',
    ahorro_esperando_acepte_post: 'to accept the invitation',
    ahorro_tu_amigo: 'your friend',

    //Ahorros — completados
    ahorros_completados_1: '1 completed',
    ahorros_completados_n: '{n} completed',
    ahorros_buscar_placeholder: '🔍 Search...',
    ahorros_sin_resultados: 'No results found',
    ahorro_completado_badge: '🎉 Completed',
    ahorro_eliminar_btn: '🗑️ Delete',

    //Ahorros — modal crear
    ahorro_modal_nuevo_ahorro: '🟠 New saving',
    ahorro_modal_nueva_deuda: '🔴 New debt',
    ahorro_nombre_placeholder: 'Name *',
    ahorro_descripcion_placeholder: 'Description (optional)',
    ahorro_meta_placeholder: 'Goal in $ (optional)',
    ahorro_compartir_amigo: '👥 Share with a friend',
    ahorro_compartir_desc_deuda: 'Your friend will see how you pay it off',
    ahorro_compartir_desc_ahorro: 'Both can contribute',
    ahorro_sin_amigos: '⚠️ You haven\'t added any friends yet',
    ahorro_usuario_generico: 'User',
    ahorro_id_label: 'ID:',
    ahorro_creando: 'Creating...',
    ahorro_guardar_btn: '💾 Save',

    //Ahorros — modal movimiento personal
    ahorro_acumulado: 'accumulated',
    ahorro_monto_placeholder: '💰 Enter an amount',
    ahorro_comprobante_opcional: '📎 Receipt (optional)',
    ahorro_subir_imagen: '📷 Upload image',
    ahorro_subiendo: 'Uploading...',
    ahorro_meter_dinero: '➕ Add money',
    ahorro_sacar_dinero: '➖ Withdraw money',

    //Ahorros — confirmar eliminar
    ahorro_confirmar_eliminar_titulo: 'Delete this saving?',
    ahorro_confirmar_eliminar_desc: 'The accumulated money will go back to your main balance.',

    //Ahorros — modal movimiento compartido
    ahorro_historial: 'HISTORY',
    ahorro_ver_comprobante_title: 'View receipt',
    ahorro_deuda_saldada: 'Debt paid off!',
    ahorro_meta_alcanzada: 'Goal reached!',
    ahorro_pagaste_todo: 'You paid it all off. Debt-free! 💪',
    ahorro_meta_lograda_juntos: 'You reached the goal together. Congratulations! 🚀',
    ahorro_comprobante_pago: '📎 Payment receipt',
    ahorro_obligatorio: '* Required',
    ahorro_subir_comprobante: '📷 Upload receipt',
    ahorro_registrar_pago: '➕ Log payment',
    ahorro_solicitar_eliminacion: '🗑️ Request deletion',
    ahorro_modo_observador: 'Viewer mode',
    ahorro_modo_observador_desc: 'Only the creator can log payments on this debt',

    //Ahorros — toasts
    toast_ahorro_ponle_nombre: 'Give the saving a name',
    toast_nombre_max_50: 'The name cannot be longer than 50 characters',
    toast_desc_max_200: 'The description cannot be longer than 200 characters',
    toast_selecciona_amigo: 'Select a friend',
    toast_error_crear: 'Error creating',
    toast_solicitud_enviada_a: 'Request sent to',
    toast_demasiadas_solicitudes: 'Too many requests sent. Wait a moment before trying again.',
    toast_cantidad_invalida: 'Invalid amount',
    toast_sin_dinero_disponible: 'You don\'t have enough money available',
    toast_sin_suficiente_ahorro: 'You don\'t have enough in this saving',
    toast_solo_hasta_meta: 'You can only add up to {monto} to complete the goal',
    toast_solo_creador_pagos_deuda: 'Only the creator can log payments on a debt',
    toast_debes_subir_comprobante: 'You must upload a payment receipt',
    toast_error_subir_comprobante: 'Error uploading receipt',
    toast_excede_meta: '⚠️ You can only contribute up to {monto} to complete the goal',
    toast_no_autorizado: '🚫 You don\'t have permission to log payments on this saving',
    toast_solo_creador_deuda: '🚫 Only the creator can log payments on this debt',
    toast_no_activo: '⚠️ This saving is not active yet',
    toast_no_existe: '⚠️ This saving doesn\'t exist',
    toast_error_registrar_pago: '⚠️ An error occurred while logging the payment',
    toast_demasiadas_solicitudes_warn: '⚠️ Too many requests sent. Wait a moment before trying again.',
    toast_ahorro_eliminado: 'Saving deleted successfully',
    toast_solicitud_eliminacion_enviada: 'Deletion request sent. The other user must accept it.',
    toast_zumbido_error: '⚠️ Could not send the buzz, try again.',
    toast_zumbido_enviado: 'Buzz sent! 📳',
    toast_imagen_invalida: 'Only JPG, PNG, WebP or HEIC images are allowed',
    toast_imagen_max_mb: 'The image cannot be larger than {mb}MB',

    //Ahorros — notificaciones guardadas para el otro usuario
    noti_invito_a_pre: 'invited you to a',
    noti_seguimiento_deuda: 'debt tracking',
    noti_ahorro_compartido: 'shared saving',
    noti_sin_descripcion: 'No description',
    noti_alguien: 'Someone',
    noti_eliminar_titulo_pre: '🗑️',
    noti_quiere_eliminar: 'wants to delete',
    noti_solicita_eliminar_pre: 'They are requesting to delete this completed',
    noti_solicita_eliminar_post: '. Do you agree?',
    noti_tu_companero: 'Your partner',
    noti_nuevo_aporte: 'New',
    noti_aporte: 'contribution',
    noti_retiro: 'withdrawal',
    noti_en: 'in',
    noti_aporto: 'contributed',
    noti_retiro_verbo: 'withdrew',
    noti_toca_ver_comprobante: 'Click to view the receipt.',
    noti_zumbido_titulo: 'Sent you a Buzz!',
    noti_revisa_tu: 'Check your:',
    //Alertas
    alertas_header: '⚠️ Alerts',
    alertas_activas: 'Active alerts',
    alertas_nombre_placeholder: 'Alert name',
    alertas_valor_placeholder: 'Amount to pay',
    alertas_mora_placeholder: 'Daily late fee %',
    alertas_crear_btn: 'Create alert',
    alertas_sin_registradas: 'No alerts recorded',
    alertas_valor_original: 'Original amount',
    alertas_mora_diaria: 'Daily late fee',
    alertas_fecha_limite: 'Due date',
    alertas_retraso_pre: '⚠️ Late by',
    alertas_retraso_post: 'days',
    alertas_nuevo_valor: 'New amount:',
    alertas_confirmar_eliminar: 'Delete this alert?',
    alertas_campos_obligatorios: 'Fill in all required fields',
    alertas_nombre_max_50: 'The name cannot be longer than 50 characters',
    alertas_desc_max_200: 'The description cannot be longer than 200 characters',
    toast_error_guardar_alerta: 'Error saving alert',
    //Analíticas
    analiticas_header: '📊 Analytics',
    analiticas_subtitulo: 'Smart financial summary',
    analiticas_cargando: 'Loading analytics...',
    analiticas_ingresos: 'Income',
    analiticas_gastos: 'Expenses',
    analiticas_ahorro: 'Savings',
    analiticas_mejor_mes: 'Best month',
    analiticas_rendimiento_anual: '📈 Annual performance',
    analiticas_recomendaciones: '🧠 Smart Recommendations',
    analiticas_mejor_mes_desc_pre: '💰 Your best month was',
    analiticas_mejor_mes_desc_post: ', where you had the highest income.',
    analiticas_peor_mes_desc_pre: '⚠️ Your month with the most expenses was',
    analiticas_ahorro_total_pre: '🎯 You have currently saved a total of',
    analiticas_ahorro_total_post: 'this year.',
    consejo_gastos_superan: '⚠️ Your expenses exceed your income. Cut unnecessary spending.',
    consejo_excelente: '🔥 Excellent financial management. Your savings rate is quite high.',
    consejo_vas_bien: "✅ You're doing well. You have a good savings capacity.",
    consejo_reducir_gastos: '💡 Try cutting small daily expenses to improve your savings.',
    mes_ene: 'Jan', mes_feb: 'Feb', mes_mar: 'Mar', mes_abr: 'Apr',
    mes_may: 'May', mes_jun: 'Jun', mes_jul: 'Jul', mes_ago: 'Aug',
    mes_sep: 'Sep', mes_oct: 'Oct', mes_nov: 'Nov', mes_dic: 'Dec',
    //Amigos
    amigos_sincronizando: 'Syncing connections...',
    amigos_volver: '← Back',
    amigos_gestiona: 'Manage your connections',
    amigos_agregar_titulo: '➕ Add friend',
    amigos_agregar_desc: 'Share your ID with someone or add theirs.',
    amigos_tu_id: 'YOUR ID',
    amigos_sin_id_pre: "⚠️ You haven't created a friend ID yet.",
    amigos_sin_id_post: 'Go to Profile and generate your ID to add friends.',
    amigos_input_placeholder: "Enter the user's ID",
    amigos_enviando: 'Sending...',
    amigos_anadir_btn: '🚀 Add friend',
    amigos_solicitudes_titulo: '📩 Pending requests',
    amigos_sin_solicitudes: "You don't have pending requests",
    amigos_aceptar: '✅ Accept',
    amigos_rechazar: '❌ Decline',
    amigos_usuario_generico: 'User',
    amigos_sin_id: 'No ID',
    amigos_tus_amigos_titulo: '👥 Your friends',
    amigos_sin_amigos: "You don't have any friends added yet",
    amigos_editar: '✏️ Edit',
    amigos_eliminar: '🗑️ Delete',
    amigos_nombre_personalizado: '✏️ Custom name',
    amigos_alias_placeholder: 'Type an alias',
    amigos_cancelar: 'Cancel',
    amigos_guardar_amigo: '💾 Save friend',
    amigos_confirmar_eliminar_titulo: 'Delete this friend?',
    amigos_confirmar_eliminar_desc: 'This action cannot be undone.',
    amigos_si_eliminar: 'Yes, delete',
    amigos_alert_ingresa_id: 'Enter an ID',
    amigos_alert_no_existe: 'No user exists with that ID',
    amigos_alert_no_agregarte: "You can't add yourself",
    amigos_alert_ya_existe: 'A request or friendship already exists',
    amigos_alert_error_enviar: 'The request could not be sent',
    amigos_alert_demasiadas: '⚠️ You sent too many requests in a row. Wait a minute and try again.',
    amigos_alert_enviada: 'Request sent 🚀',
    amigos_alert_nickname_max: 'The custom name cannot be longer than 30 characters',
    amigos_alert_error_aceptar: 'The request could not be accepted',
    amigos_alert_amigo_agregado: '🎉 Friend added',
    amigos_alert_error_eliminar: 'The friend could not be deleted',
    amigos_alert_amigo_eliminado: '🗑️ Friend deleted',
    amigos_alert_error_rechazar: 'Could not decline',
    mensajes_header: 'Messages',
    //Mensajes
    sin_conversaciones: 'No conversations',
    agrega_amigos_chatear: 'Add friends to start chatting',
    sin_mensajes_aun: 'No messages yet',
    tu_dos_puntos: 'You: ',
    no_hay_mensajes_decir_hola: 'No messages yet. Say hi! 👋',
    escribir_mensaje_placeholder: 'Type a message...',
    usuario_generico: 'User',
    cargando_mensajes: 'Loading messages...',
    cal_movimientos_dia: 'Transactions for day {dia}',
    //Calendario
    cal_agregar_ingreso: '➕ Add Income',
    cal_agregar_gasto: '➕ Add Expense',
    cal_no_hay_movimientos: 'No transactions',
    cal_mora_diaria_valor: 'Daily late fee: {pct}%',
    cal_seleccionar_fecha: '📅 Select date',
    cal_mes_label: 'Month',
    cal_anio_label: 'Year',
    cal_aplicar: 'Apply',
    cal_enero: 'January', cal_febrero: 'February', cal_marzo: 'March', cal_abril: 'April',
    cal_mayo: 'May', cal_junio: 'June', cal_julio: 'July', cal_agosto: 'August',
    cal_septiembre: 'September', cal_octubre: 'October', cal_noviembre: 'November', cal_diciembre: 'December',
    dia_lun: 'M', dia_mar: 'T', dia_mie: 'W', dia_jue: 'T', dia_vie: 'F', dia_sab: 'S', dia_dom: 'S',
    //BonzaiBot
    // ── Factura Scanner ──
    factura_btn_label: 'INVOICE',
    factura_tooltip: '📄 Scan invoice (QR + AI)',
    factura_tomar_foto: '📸 Take photo',
    factura_elegir_galeria: '🖼️ Choose from gallery',
    factura_ingresar_manual: '✏️ Enter manually',
    factura_qr_detectado: '✅ QR detected',
    factura_analizada: '🤖 Invoice analyzed',
    factura_ingresa_datos: '✏️ Enter the details',
    factura_no_pudo_leer: "Couldn't read it automatically. Fill in the details.",
    factura_verifica_datos: 'Verify the details before saving',
    factura_monto_total: 'TOTAL AMOUNT *',
    factura_categoria_label: 'CATEGORY *',
    factura_nombre_categoria: 'YOUR CATEGORY NAME',
    factura_categoria_custom_placeholder: 'E.g.: Pets, Gym, Gift...',
    factura_fecha_label: 'DATE',
    factura_desc_label: 'DESCRIPTION (optional)',
    factura_desc_placeholder: 'E.g.: Lunch',
    factura_registrar_gasto: '💸 Log expense',
    factura_cancelar: '✕ Cancel',
    factura_monto_invalido: 'Enter a valid amount',
    factura_usuario_no_identificado: 'User not identified',
    factura_selecciona_categoria_error: 'Select a category',

    // ── Suggestion Box ──
    sugerencia_tooltip: 'Suggestions',
    sugerencia_titulo: '💡 Your suggestion',
    sugerencia_placeholder: 'What would you like us to improve?',
    sugerencia_enviando: 'Sending...',
    sugerencia_enviar: 'Send suggestion',
    sugerencia_muy_larga_titulo: 'Suggestion too long',
    sugerencia_muy_larga_desc: 'Maximum 500 characters',
    sugerencia_no_permitido_titulo: 'Not allowed',
    sugerencia_no_permitido_desc: 'Your suggestion contains content that is not allowed',
    sugerencia_gracias_titulo: 'Thank you!',
    sugerencia_gracias_desc: 'Your suggestion was sent 🙌',
    sugerencia_error_titulo: 'Error',
    sugerencia_error_desc: 'Something went wrong, try again',

    // ── Home: fecha y mensajes dinámicos ──
    home_fecha_locale: 'en-US',
    bonzai_msg_1: "👀 Heads up... that alert is patiently waiting while you dodge responsibilities.",
    bonzai_msg_2: "💸 Your money said: 'please don't make me pay late fees again'.",
    bonzai_msg_3: '⏰ Time is ticking... and so are the bills.',
    bonzai_msg_4: "That alert won't pay itself, champ.",
    bonzai_msg_5: '🚨 Financial alert detected: possible procrastination attack.',
    bonzai_msg_6: '😭 Your future self is begging you to pay everything on time.',
    saving_msg_1: '🫣 Your financial self is waiting for a saving, even if it\'s just $5.',
    saving_msg_2: '💸 Creating a debt counts as organizing... technically.',
    saving_msg_3: "😟 Whatever you're dreaming of won't buy itself if you don't save.",
    saving_msg_4: '🐷 The piggy bank pig must be as full as you are.',
    saving_msg_5: '🚀 A small saving still beats zero.',
    saving_msg_6: '😎 Financial goals also count as character development.',
    saving_msg_7: '👻 Cut the small unnoticed expenses, start saving.',
    income_msg_zero_1: '🫣 Your wallet is waiting for its big moment.',
    income_msg_zero_2: '👀 Zero income... the calm before the financial storm.',
    income_msg_zero_3: "🌵 Drier than the desert, but it can all change.",
    income_msg_low_1: '🌱 Every great financial empire starts small.',
    income_msg_low_2: "🐣 You're barely hatching that cash flow.",
    income_msg_low_3: '🔋 Loading income... 12% complete.',
    income_msg_mid_1: '💸 You\'re building up some pretty decent income.',
    income_msg_mid_2: '📈 This is starting to look like a plan.',
    income_msg_mid_3: '🙌 Not bad, keep it up champ.',
    income_msg_high_1: '🚀 That money flow already feels powerful.',
    income_msg_high_2: "👑 You're in tycoon mode for now.",
    income_msg_high_3: '🔥 Income on fire, in the good way.',
    expense_msg_zero_1: "😎 Incredible... not a single peso spent so far.",
    expense_msg_zero_2: "🧘 Total calm, your money hasn't suffered at all.",
    expense_msg_zero_3: '🛡️ Expenses: 0. You\'re invincible (for now).',
    expense_msg_low_1: '🧠 Your expenses are still pretty under control.',
    expense_msg_low_2: '✅ Successful beginner-level financial discipline.',
    expense_msg_low_3: '🧊 Nice and cold expenses, all under control.',
    expense_msg_mid_1: "💸 Some money left... but everything's under control.",
    expense_msg_mid_2: '🌀 Expenses are starting to move, watch out for that.',
    expense_msg_mid_3: '🧾 Some bills decided to join the party.',
    expense_msg_high_1: '💀 Your expenses unlocked legend mode.',
    expense_msg_high_2: '🔥 Your wallet is calling for help.',
    expense_msg_high_3: "🌪️ That's not an expense anymore, it's a category 5 hurricane.",
    Escanear_facturaqr: "📄 Scan invoice",
    perfil_loading_titulo: 'Profile',
    perfil_loading_desc: 'Preparing your personal space...',
    suscripcion_header: '💳 Subscription',
    suscripcion_plan_nombre: 'Calypso subscription',
    suscripcion_periodicidad: 'Billed monthly',
    suscripcion_periodicidad_anual: 'Billed yearly',
    suscripcion_plan_mensual: 'Monthly',
    suscripcion_plan_anual: 'Yearly',
    suscripcion_nota_conversion: 'The charge is processed in Colombian pesos (COP) at the current exchange rate.',
    suscripcion_beneficio_1: 'Unlimited advanced analytics',
    suscripcion_beneficio_2: 'Unlimited invoice scanning',
    suscripcion_beneficio_3: 'Unlimited shared savings',
    suscripcion_beneficio_4: 'Priority support',
    suscripcion_pagar_btn: '💳 Pay',
    suscripcion_procesando: 'Processing...',
    suscripcion_error_generico: 'Something went wrong starting the payment. Try again.',
    suscripcion_error_widget: 'Could not load the payment widget.',
    suscripcion_pago_aprobado: 'Payment approved! Your subscription will activate shortly.',
    suscripcion_pago_pendiente: 'Your payment is pending confirmation.',
    suscripcion_pago_rechazado: 'Payment declined. Try a different method.',
    suscripcion_pago_error: 'There was a problem with the payment. Try again.',
    suscripcion_nota_seguridad: 'Payments securely processed.',
    suscripcion_perfil_titulo: 'Calypso Suscribed',
    suscripcion_perfil_desc: 'Unlock advanced features',
    suscripcion_activa_badge: 'Active',
    suscripcion_vence_pre: 'Expires on',
    paywall_trial_titulo: '🎁 You are in your free trial',
    paywall_vencido_titulo: '🔒 Your free trial ended',
    paywall_trial_desc_pre: 'You have',
    paywall_trial_desc_post: 'left. This feature will stay available after that if you activate your subscription.',
    paywall_vencido_desc: 'Activate your subscription to keep using this feature and all of Calypso\'s tools.',
    paywall_dia: 'day',
    paywall_dias: 'days',
    paywall_btn: '⭐ View subscription',
    // ── Creators ──
    creadores_header_titulo: 'Creators',
    creadores_header_subtitulo: 'The team behind the app',
    creadores_cerrar_btn: 'Close',
    creadores_apoyar_btn: 'Support',
    creadores_kicker: 'A story of code and coffee',
    creadores_titulo_principal: '🚀 Thanks for using our app',
    creadores_parrafo_1: 'This app was born from a simple idea: make managing your money easy, beautiful, and hassle-free. Every screen, every animation, every detail was crafted with care so you can focus on what matters.',
    creadores_parrafo_2: "Behind it are long nights, cold cups of coffee, bugs that show up at the worst possible time, and the huge satisfaction of seeing something we built from scratch actually work. We're not a big company and we don't have investors. We're real people who bet on this.",
    creadores_fundadores_titulo: 'Founders',
    creadores_dev_titulo: 'Developer & Lead Dev',
    creadores_dev_desc: "Design, code, testing, deployment. One single brain behind every feature. If something works well, he did it. If something breaks... also him. 😅",
    creadores_parrafo_3: 'Every person who uses the app gives us one more reason to keep going. But if you want to go a step further and support this venture, any contribution, no matter how small, helps us pay for servers, the domain, and keep building.',
    creadores_parrafo_4: 'Thank you, truly. Not in that generic "thanks for using our product" way. Truly, person to person, for trusting something we made with our own hands. 💜',
    creadores_footer_texto: 'Made with love · Colombia 🇨🇴 ♥',
    creadores_panel_titulo: '☕ Choose how to support us',
    creadores_banco_tipo_cuenta: 'Savings',
    creadores_banco_numero_label: 'Account number',
    creadores_banco_titular_label: 'Account holder',
    //Declaracion de Renta 
    declaracion_renta_card_titulo: 'Tax return (Colombia)',
    declaracion_renta_card_desc: 'Helps you organize your data to file taxes in Colombia.',
    declaracion_renta_card_cta: 'CLICK TO VIEW 🧾',

    declaracion_header: 'Tax Return',
    declaracion_aviso_colombia: '⚠️ This section applies only to users in Colombia.',
    declaracion_cedula_pedir: 'Before generating your summary, we need your ID number (cédula).',
    declaracion_cedula_placeholder: 'ID number (cédula)',
    declaracion_guardar_cedula: 'Save ID number',
    declaracion_guardando_cedula: 'Saving...',
    declaracion_error_guardar_cedula: 'Could not save the ID number. Try again.',
    declaracion_periodo_titulo: 'Select the period to declare',
    declaracion_generar_btn: 'Generate automatic summary',
    declaracion_generando: 'Generating...',
    declaracion_falta_cedula_nota: 'Save your ID number above to generate the summary.',
    declaracion_error_fechas: 'Select the full date range.',
    declaracion_error_generar: 'Could not generate the summary. Try again.',
    declaracion_cedula_label: 'ID number:',
    declaracion_periodo_label: 'Period:',
    declaracion_ingresos_label: 'INCOME',
    declaracion_gastos_label: 'EXPENSES',
    declaracion_neto_label: 'NET',
    declaracion_ingresos_por_categoria: 'Income by category',
    declaracion_gastos_por_categoria: 'Expenses by category',
    declaracion_sin_ingresos_periodo: 'No income in this period',
    declaracion_sin_gastos_periodo: 'No expenses in this period',
    declaracion_imprimir_btn: '🖨️ Print / Save as PDF',
    declaracion_cargando: 'Loading...',
    declaracion_neto_nota: '(not your taxable income)',
    declaracion_topes_titulo: '📌 Do I need to file? Reference thresholds (2025 tax year)',
    declaracion_topes_texto: 'You must file if in 2025 you exceeded at least one of: gross assets over 4,500 UVT ($224,096,000 COP), gross income of 1,400 UVT or more ($69,719,000 COP), credit card purchases, purchases or bank deposits over 1,400 UVT, or if you were VAT-responsible. This is reference only, verify your case with DIAN or an accountant.',
    declaracion_disclaimer: 'This summary is a beta support tool from Calypso. It is not an official DIAN document, has no tax validity, and cannot be filed as a tax return. Calculations and classifications are for guidance only — always confirm with an accountant or directly on the MUISCA portal before filing.',
    forgot_password_title: 'Forgot your password?',
    forgot_password_desc: "Enter your email and we'll send you a link to create a new password.",
    forgot_password_email_label: 'Email',
    forgot_password_email_placeholder: 'youremail@example.com',
    forgot_password_error_required: 'Email is required',
    forgot_password_error_invalid: 'Invalid email',
    forgot_password_error_rate_limit: 'Too many attempts. Wait a few minutes and try again.',
    forgot_password_sending: 'Sending...',
    forgot_password_send_btn: 'Send link →',
    forgot_password_back_login: '← Back to sign in',
    forgot_password_sent_title: 'Check your email',
    forgot_password_sent_desc: "If {email} is registered, you'll receive a link to reset your password.",
    forgot_password_sent_expire: 'Click the link in the email to set a new password. The link expires in {time}.',
    forgot_password_expire_time: '1 hour',
    forgot_password_no_email: "Didn't get the email? Check your spam folder or",
    forgot_password_try_another: 'try another email',
    login_error_email_required: 'Email is required',
    login_error_email_invalid: 'Invalid email',
    login_error_password_required: 'Password is required',
    login_error_invalid_credentials: 'Incorrect email or password.',
    login_error_email_not_confirmed: 'You must confirm your email before signing in.',
    login_error_generic: 'Something went wrong. Try again.',
    login_title: 'Welcome back',
    login_subtitle: 'Sign in to your account to continue',
    login_email_label: 'Email',
    login_email_placeholder: 'youremail@example.com',
    login_password_label: 'Password',
    login_password_placeholder: 'Your password',
    login_forgot_password: 'Forgot your password?',
    login_loading: 'Signing in...',
    login_submit: 'Sign in →',
    login_no_account: "Don't have an account?",
    login_register_link: 'Sign up for free',

    unlock_ahora_no: 'Not now',
    actualizacion_nunca: 'not updated yet',
    actualizacion_menos_1_min: 'less than a minute ago',
    actualizacion_minutos: '{n} minutes ago',
    actualizacion_horas: '{n} hours ago',
    suscripcion_trial_activa: 'Free trial · expires in',
    suscripcion_trial_vencida: 'Your free trial ended · subscribe to keep using Calypso',
    dia_singular: 'day',
    dias_plural: 'days',
    recargar_sesiones: 'Refresh',

    modal_cerrar_sesiones_titulo: 'Close all sessions except this one?',
    modal_cerrar_sesiones_desc: "You'll need to sign in again on your other devices.",
    modal_cerrar_sesiones_confirmar: 'Yes, close sessions',
    modal_cancelar: 'Cancel',
    modal_generar_id_titulo_ya: '⚠️ You already have an ID',
    modal_generar_id_titulo_nuevo: 'Generate friend ID',
    modal_generar_id_desc_ya: 'This will replace your current ID. The old one will stop working.',
    modal_generar_id_desc_nuevo: 'This will generate a unique ID so others can add you as a friend.',
    modal_generar_id_confirmar_ya: 'Yes, replace it',
    modal_generar_id_confirmar_nuevo: 'Yes, generate',
    //I.A
    ia_analizando: 'Analyzing your finances',
    ia_bienvenida: "Hi {name}! 👋 I'm your personal financial assistant.\n\nI've loaded your financial info from the last 3 months. I can help you understand your spending patterns, evaluate your savings goals, and give you personalized advice based on your real data.\n\nWhat would you like to know today? 💡",
    ia_error_procesar: '⚠️ There was a problem processing your request. Please try again in a few seconds.',
    ia_sin_conexion_titulo: 'No internet connection',
    ia_sin_conexion_desc: 'You need to be connected to the internet to talk to your financial assistant.',
    ia_volver_inicio: 'Back to home',
    ia_preparando_titulo: 'Preparing your assistant',
    ia_preparando_desc: 'Loading your financial information...',
    ia_header_titulo: 'Financial assistant',
    ia_header_estado: '● Active · Only answers about your finances',
    ia_datos_listos: '✓ Data ready',
    ia_ultimos_3_meses: 'Last 3 months',
    ia_privacidad_chip: '🔒 Your data is private and not stored in the chat',
    ia_preguntas_sugeridas: 'Suggested questions',
    ia_input_placeholder: 'Ask about your finances...',
    ia_footer_hint: 'Only answers questions about your personal finances · Enter to send',
    ia_sugerencia_1: 'How are my finances doing this month?',
    ia_sugerencia_2: 'What am I spending the most on?',
    ia_sugerencia_3: 'Can I afford to save more?',
    ia_sugerencia_4: 'How am I doing with my savings goals?',
    ia_sugerencia_5: 'Give me a tip to cut expenses',
    ia_sugerencia_6: "What's my overall balance?",
    //FacturaEscaner
    factura_sin_internet_error: 'You need an internet connection to scan the receipt.',
    factura_error_procesar_imagen: 'Error processing image:',
    factura_error_guardar: 'Error saving:',
    factura_fuente_qr: 'QR data',
    factura_fuente_vision: 'Claude Vision',
    factura_fuente_manual: 'Manual',
    factura_sin_logs: 'No logs yet...',
    factura_aria_escanear: 'Scan receipt',
    factura_menu_sin_internet: "You're offline. You'll be able to enter the data manually once you're back online.",
    factura_guia_titulo: 'How to take the photo',
    factura_guia_tip_internet: 'You need an internet connection to analyze the receipt.',
    factura_guia_tip_1: 'Focus on where it says "TOTAL" or "AMOUNT DUE"',
    factura_guia_tip_2: 'Make sure the text is sharp and well lit',
    factura_guia_tip_3: "Don't photograph just the QR code — it doesn't contain the amount",
    factura_guia_boton_foto: 'Take photo',
    factura_analizando_titulo: 'Analyzing receipt...',
    factura_analizando_desc: 'Reading receipt with Claude Vision...',
    factura_guardando_titulo: 'Saving expense...',
    factura_exito_titulo: 'Expense recorded!',
    factura_exito_fuente: 'Source:',
    //Elimicacion de cuenta
    eliminar_cuenta_boton: 'Delete my account',
    eliminar_cuenta_titulo: 'Delete Calypso account',
    eliminar_cuenta_intro: 'This page lets you request permanent deletion of your Calypso (Bonzzai Enterprise) account and associated data, in compliance with Google Play account deletion policies.',
    eliminar_cuenta_que_titulo: 'What gets deleted?',
    eliminar_cuenta_item1: 'Your profile (name, photo, email)',
    eliminar_cuenta_item2: 'Recorded income, expenses, and financial data',
    eliminar_cuenta_item3: 'Shared savings, alerts, messages, and active sessions',
    eliminar_cuenta_item4: 'Your authentication account',
    eliminar_cuenta_aviso: 'This action is irreversible. Billing records managed by Google Play/RevenueCat are retained for up to 90 additional days for accounting and fraud-prevention requirements.',
    eliminar_cuenta_login_req: 'To delete your account, please log in first.',
    eliminar_cuenta_login_btn: 'Log in',
    eliminar_cuenta_continuar: 'Continue with deletion',
    eliminar_cuenta_confirmar_texto: 'Type DELETE to confirm you want to delete the account for',
    eliminar_cuenta_confirmar_btn: 'Permanently delete account',
    eliminar_cuenta_eliminando: 'Deleting...',
    eliminar_cuenta_exito: 'Your account has been deleted',
    eliminar_cuenta_error: 'Account could not be deleted',
    eliminar_cuenta_error_desc: 'Please try again or contact us.',
    eliminar_cuenta_confirm_warning: 'Type DELETE to confirm',
    eliminar_cuenta_palabra_confirmacion: 'DELETE',
    eliminar_datos_titulo: 'Delete data in Calypso',
    eliminar_datos_intro: 'Calypso (Bonzzai Enterprise) lets you delete specific data from your account without deleting the entire account. The steps for each data type are detailed below.',
    eliminar_datos_transacciones_titulo: 'Transactions (income and expenses)',
    eliminar_datos_transacciones_desc: 'Open the app → Income or Expenses → press and hold or swipe on the entry → tap "Delete". The data is removed from our database immediately.',
    eliminar_datos_foto_titulo: 'Profile photo',
    eliminar_datos_foto_desc: 'Open Profile → hover over your photo → tap the trash icon. The image is removed from our storage immediately.',
    eliminar_datos_sugerencias_titulo: 'Suggestions submitted to the community',
    eliminar_datos_sugerencias_desc: 'Open the Suggestions section → find your suggestion → tap "Delete". It is removed immediately and is no longer visible to other users.',
    eliminar_datos_conservados: 'Data that is retained:',
    eliminar_datos_conservados_desc: 'billing records managed by Google Play/RevenueCat are retained for up to 90 additional days for accounting and fraud-prevention requirements.',
    eliminar_datos_pregunta_cuenta: 'Want to delete your entire account instead of individual data?',
    eliminar_datos_link_cuenta: 'Go here',
    //YA ESTAS SUCRITO
    suscripcion_ya_suscrito_titulo: 'You\'re already subscribed',
    suscripcion_activa_sin_fecha: 'Your subscription is active.',
    suscripcion_gestionar_playstore: 'Manage subscription on Google Play',
    suscripcion_gestionar_soporte: 'Contact support to manage my subscription',
    //DECLARACION RENTA
    declaracion_ingresos_por_cedula: 'Income by tax category',
    declaracion_revisar_manual_titulo: 'Manual review needed',
    declaracion_revisar_manual_desc: 'These income items couldn\'t be classified automatically. Check which category they belong to before filing.',
    declaracion_cedula_trabajo: 'Employment income',
    declaracion_cedula_capital: 'Capital income',
    declaracion_cedula_no_laboral: 'Non-labor income',
    declaracion_cedula_pensiones: 'Pension income',
    declaracion_cedula_dividendos: 'Dividends and shareholdings',
    declaracion_cedula_ganancia_ocasional: 'Occasional gains',
    declaracion_cedula_no_clasificado: 'Unclassified',
    declaracion_badge_beta: 'Beta',
    declaracion_descargar_btn: 'Download summary',
    declaracion_confirmar_descarga: 'This summary is for reference only and does not replace your official DIAN tax return. Continue?',
    declaracion_requiere_suscripcion_titulo: 'Subscriber-only feature',
    declaracion_requiere_suscripcion_desc: 'The tax return summary is only available for users with an active subscription (not included in the free trial).',
    declaracion_datos_adicionales_titulo: 'Additional data for your tax return',
    declaracion_datos_adicionales_desc: 'These figures aren\'t calculated from your transactions. Fill them in manually to get a summary closer to your real tax return.',
    declaracion_campo_patrimonio_bruto: 'Gross net worth (total assets)',
    declaracion_campo_deudas: 'Debts',
    declaracion_campo_retenciones: 'Withholding tax already deducted',
    declaracion_campo_aportes_pension: 'Voluntary pension contributions',
    declaracion_campo_aportes_afc: 'AFC savings account contributions',
    declaracion_campo_intereses_vivienda: 'Home loan interest',
    declaracion_campo_medicina_prepagada: 'Private health insurance',
    declaracion_campo_dependientes: 'Number of economic dependents',
    declaracion_error_cargar_datos_fiscales: 'Couldn\'t load your tax data.',
    declaracion_error_guardar_datos_fiscales: 'Couldn\'t save your tax data.',
    declaracion_datos_guardados_ok: 'Data saved successfully.',
    declaracion_guardando: 'Saving...',
    declaracion_guardar_datos: 'Save data',
    declaracion_confirmar_descarga_titulo: 'Before you continue',
    declaracion_confirmar_descarga_btn: 'Yes, download',
    declaracion_error_pdf: "We couldn't generate the PDF. Please try again.",
    declaracion_generando_pdf: 'Generating PDF...',
    // ── Quick templates: shared ──
    pl_boton: 'Quick add',
    pl_nueva: 'New template',
    pl_editar: 'Edit template',
    pl_agregar: 'Add',
    pl_agregado_ok: 'Added',
    pl_nota_fecha: 'They are added with today\'s date',
    pl_err_monto: 'Amount must be greater than 0',
    pl_err_categoria: 'Select or type a category',
    pl_err_categoria_larga: 'Category cannot be longer than 50 characters',
    pl_err_desc_larga: 'Description cannot be longer than 200 characters',
    pl_err_guardar: 'Could not save the template',
    pl_err_agregar: 'Could not add the records. Please try again.',
    // ── Quick templates: income ──
    pl_titulo_ingreso: 'Quick income',
    pl_desc_ingreso: 'Your fixed income, ready to add with one tap',
    pl_vacio_ingreso: 'You have no fixed income yet. Create one, like your salary.',
    // ── Quick templates: expenses ──
    pl_titulo_gasto: 'Quick expenses',
    pl_desc_gasto: 'Your fixed expenses, ready to add with one tap',
    pl_vacio_gasto: 'You have no fixed expenses yet. Create one, like your rent.',
    // ── Tutorial ──
    tour_siguiente: 'Next',
    tour_anterior: 'Back',
    tour_listo: 'Done!',
    tour_ayuda: 'Tutorials',
    tour_ayuda_desc: 'Pick a section and we\'ll guide you step by step',
    tour_menu_ingresos: 'Income tutorial',
    tour_menu_gastos: 'Expenses tutorial',
    // Shared
    tour_mes_t: 'Change month',
    tour_mes_d: 'Pick another month to view and record entries for that period.',
    tour_import_t: 'Import your statement with AI',
    tour_import_d: 'Upload your bank file (CSV, TXT, XML or PDF) and the AI detects the entries for you. Tap Next to see how.',
    tour_pais_t: 'Choose your country and upload the file',
    tour_pais_d: 'Select your country so the AI understands date and currency formats, then upload the statement. You can review and edit everything before importing.',
    tour_plantillas_t: 'Quick entries',
    tour_filtro_t: 'Filter by category',
    tour_filtro_d: 'Show only entries from one category or search for a custom one.',
    // Income
    tour_ing_total_t: 'Your income this month',
    tour_ing_total_d: 'See how much you have received in the selected month. Tap the chart to go to Analytics.',
    tour_ing_form_t: 'Record income',
    tour_ing_form_d: 'Enter the amount, pick the date and category, add a description if you like, and tap "Add income".',
    tour_ing_lista_t: 'Your income',
    tour_ing_lista_d: 'This month\'s income shows up here. Use ✏️ to change the amount and 🗑️ to delete the entry.',
    // Expenses
    tour_gas_total_t: 'Your expenses this month',
    tour_gas_total_d: 'See how much you have spent in the selected month. Tap the chart to go to Analytics.',
    tour_gas_form_t: 'Record an expense',
    tour_gas_form_d: 'Enter the amount, pick the date and category, add a description if you like, and tap "Add expense".',
    tour_gas_lista_t: 'Your expenses',
    tour_gas_lista_d: 'This month\'s expenses show up here. Use ✏️ to change the amount and 🗑️ to delete the entry.',
    tour_plantillas_d: 'Save your fixed entries here, like salary or rent. Tap Next and we\'ll open it for you.',
    tour_pl_nueva_t: 'Create a template',
    tour_pl_nueva_d: 'Use this button to create a fixed entry. Now we\'ll show you the form.',
    tour_pl_form_t: 'Fill in your template',
    tour_pl_form_d: 'Try it: enter the amount, pick the category and, if you like, a description (for example "Salary"). If you save it, it will stay as your first template. Or tap Next to continue without saving.',
    tour_pl_lista_t: 'Your templates',
    tour_pl_lista_d: 'The ones you created show up here. Check or uncheck the ones you want to add, and use ✏️ to edit or 🗑️ to delete them.',
    tour_pl_agregar_t: 'Add them in one tap',
    tour_pl_agregar_d: 'This button instantly adds every checked template with today\'s date, without typing anything.',
    tour_menu_home: 'Home tutorial',
    tour_menu_ahorro: 'Savings & Debts tutorial',
    // Home
    tour_home_bienvenida_t: 'Welcome to Calypso!',
    tour_home_bienvenida_d: 'Let\'s take a quick tour of the home screen. Tap Next to begin.',
    tour_home_periodo_t: 'Pick your period',
    tour_home_periodo_d: 'See your numbers by month or switch to the overall view to see your full history.',
    tour_home_ingresos_t: 'Your income',
    tour_home_ingresos_d: 'How much you have received in the period. Tap the card to go log income.',
    tour_home_gastos_t: 'Your expenses',
    tour_home_gastos_d: 'How much you have spent in the period. Tap the card to go log an expense.',
    tour_home_balance_t: 'Your balance',
    tour_home_balance_d: 'Income minus expenses. Tap the card to see your analytics.',
    tour_home_ahorro_t: 'Savings and debts',
    tour_home_ahorro_d: 'Your featured saving or debt rotates here with its progress. Tap the card to manage them.',
    tour_home_renta_t: 'Tax return',
    tour_home_renta_d: 'Organize your data to file taxes in Colombia.',
    tour_home_herr_t: 'Quick tools',
    tour_home_herr_d: 'Scan an invoice, send a suggestion, or browse the community suggestions wall.',
    tour_home_extras_t: 'More options',
    tour_home_extras_d: 'This arrow expands the bar with your notifications and alerts. Tap Next and we\'ll open it for you.',
    tour_home_notif_t: 'Notifications',
    tour_home_notif_d: 'The bell tells you about friend requests, shared savings, messages and buzzes. The red number is how many you haven\'t read.',
    tour_home_panel_t: 'Your inbox',
    tour_home_panel_d: 'Your notifications show up here. You can accept or decline requests, mark all as read, or remove one with ✕.',
    tour_home_alertas_t: 'Alerts',
    tour_home_alertas_d: 'Your payment reminders with due dates and late fees. It shakes when you have pending alerts.',
    tour_home_perfil_t: 'Your profile',
    tour_home_perfil_d: 'Your photo or initial takes you to your profile: language, colors, currency, themes and sessions.',
    tour_home_nav_t: 'Navigation',
    tour_home_nav_d: 'From here you can go to the calendar, friends, messages and the AI assistant.',
    // Savings
    tour_aho_resumen_t: 'Your summary',
    tour_aho_resumen_d: 'Available is the free money in your balance and Total saved is what you have stored in your savings.',
    tour_aho_nuevo_t: 'Create a saving or debt',
    tour_aho_nuevo_d: 'Use this button to create a new one. Tap Next and we\'ll show you the form (nothing gets saved).',
    tour_aho_tipo_t: 'Saving or debt',
    tour_aho_tipo_d: 'Choose whether it\'s a savings goal or a debt you want to pay off.',
    tour_aho_datos_t: 'The details',
    tour_aho_datos_d: 'Give it a name, an optional description and an optional goal amount to track your progress.',
    tour_aho_compartir_t: 'Share it with a friend',
    tour_aho_compartir_d: 'Turn this on to save together with a friend, or so they can see how you pay off a debt. Your friend must accept the invitation.',
    tour_aho_personales_t: 'Your personal savings',
    tour_aho_personales_d: 'Each card shows the accumulated amount, the goal and the progress. Tap one to add or withdraw money. We\'ll show you how.',
    tour_aho_mov_monto_t: 'Enter the amount',
    tour_aho_mov_monto_d: 'Type how much to add or withdraw. Adding takes it from your available money and withdrawing returns it.',
    tour_aho_mov_comprobante_t: 'Receipt',
    tour_aho_mov_comprobante_d: 'Optionally attach a photo of the receipt. For shared savings it is required.',
    tour_aho_mov_acciones_t: 'Actions',
    tour_aho_mov_acciones_d: 'Add or withdraw money, or delete the saving (the accumulated money goes back to your balance).',
    tour_aho_compartidos_t: 'Shared savings',
    tour_aho_compartidos_d: 'Here you see what you save with friends: each person\'s contribution, the progress and the 📳 Buzz button to nudge your friend. Completed ones are kept under 🎉, and shared debts are read-only for whoever didn\'t create them.',
    tour_aho_vacio_t: 'No savings yet',
    tour_aho_vacio_d: 'When you create your first saving or debt it will show up here. Open this tutorial again and we\'ll show you how to manage them.',  
  //NUEVOS TEMAS
      saludo_halloween: '🎃 Happy Halloween,',
    saludo_navidad: '🎄 Merry Christmas,',
    saludo_colombia: '☕ Hey there,',
    saludo_cerveza: '🍺 Cheers,',
    cargando_halloween: 'Waking up the ghosts...',
    cargando_navidad: 'Hanging the lights...',
    cargando_colombia: 'Brewing the coffee...',
    cargando_cerveza: 'Pouring the foam...',
    tema_worldcup_nombre: 'World Cup 2026',
    tema_worldcup_desc: 'Stadiums, football, trophies and World Cup spirit.',
    tema_halloween_nombre: 'Halloween',
    tema_halloween_desc: 'Pumpkins, ghosts and spooky nights.',
    tema_navidad_nombre: 'Christmas',
    tema_navidad_desc: 'Snow, lights and holiday spirit.',
    tema_colombia_nombre: 'Colombia',
    tema_colombia_desc: 'Coffee, mountains and the colors of the flag.',
    tema_cerveza_nombre: 'Beer',
    tema_cerveza_desc: 'Foam, toasts and a good party.',
    tema_badge_desbloqueado: 'Theme unlocked!',
    tema_aplicar: '✨ Apply theme',
    tema_toast_desbloqueado: 'Theme unlocked',
    tema_toast_desbloqueado_desc: '{tema} is now available in your profile.',
  },

  fr: {
    // ── Perfil ──
    perfil_titulo: 'Mon profil',
    perfil_subtitulo: "Paramètres de l'utilisateur",
    cambiar_foto: '📷 Changer la photo',
    idioma_titulo: '🌐 Langue',
    idioma_desc: "Choisissez la langue dans laquelle vous voulez voir l'application.",
    canjear_codigo: 'Échanger un code',
    canjear_placeholder: '🎁 Entrez votre code',
    canjear_validando: 'Validation...',
    canjear_boton: 'Échanger le code',
    id_amigo_titulo: "🆔 ID d'ami",
    id_amigo_desc: "Cet ID sera utilisé pour que d'autres utilisateurs puissent t'ajouter comme ami.",
    no_generado: 'Non généré',
    regenerar: '🔄 Régénérer',
    generar: '⚡ Générer',
    correo_titulo: '📧 E-mail',
    correo_desc: 'Si tu changes ton e-mail, tu recevras un message de confirmation.',
    editar: '✏️ Modifier',
    bloquear: '🔒 Verrouiller',
    nombre_titulo: "✏️ Nom affiché",
    nombre_desc: "Ce nom sera celui que verront les autres utilisateurs dans l'application.",
    nombre_placeholder: 'Ton nom affiché',
    vista_titulo: '👁️ Vue préférée',
    vista_desc_pre: "Enregistre quelle vue de ton argent tu préfères à l'accueil, soit",
    vista_mensual: 'mensuelle',
    vista_general: 'générale',
    vista_general_activa: '🌎 Vue générale activée',
    vista_mensual_activa: '📅 Vue mensuelle activée',
    color_titulo: "🎨 Couleur de l'app",
    color_desc: "Choisis la palette visuelle de toute l'application.",
    activo: '✓ Actif',
    toca_aplicar: 'Touchez pour appliquer',
    temas_titulo: '🎭 Thèmes',
    temas_desc: "Change complètement l'apparence de l'application.",
    sin_temas: "Tu n'as encore débloqué aucun thème. Échange un code pour en débloquer un 🎁",
    moneda_titulo: "💱 Devise de l'app",
    moneda_desc: "Choisis la devise utilisée pour afficher les prix dans toute l'application.",
    moneda_aviso: "⚠️ Les montants enregistrés peuvent varier si tu changes de devise. Les valeurs historiques seront recalculées avec le taux de change actuel, ce qui peut entraîner de légères différences. Nous recommandons d'utiliser une seule devise et d'éviter de la changer, sauf si c'est vraiment nécessaire. Remarque : le taux de conversion est mis à jour toutes les 6 heures. Garde cela en tête avant de convertir, car la valeur affichée peut différer légèrement de celle appliquée lors des prochaines mises à jour.",
    sesiones_titulo: '🔐 Sessions actives',
    sesiones_desc: 'Appareils où tu as une session ouverte. Ferme celles que tu ne reconnais pas.',
    cargando_sesiones: 'Chargement des sessions...',
    sin_sesiones: 'Aucune session enregistrée',
    esta_sesion: 'Cette session',
    cerrar: 'Fermer',
    cerrar_otras_sesiones: '🔒 Fermer toutes les autres sessions',
    ultimo_acceso: 'Dernière connexion',
    tiempo_ahora: "À l'instant",
    tiempo_min: 'Il y a {n} min',
    tiempo_hora: 'Il y a {n}h',
    tiempo_dia: 'Il y a {n}j',
    password_titulo: '🔑 Changer le mot de passe',
    password_desc_pre: 'Nous enverrons un e-mail à',
    password_desc_post: 'avec un lien pour changer ton mot de passe.',
    enviar_enlace: '📧 Envoyer le lien',
    creadores: 'Créateurs',
    guardar: '💾 Enregistrer',
    guardando: 'Enregistrement...',

    // ── Home ──
    proximamente: 'Bientôt disponible',
    modo_negocio: 'Mode 🏪 Entreprise',
    modo_personal: 'Mode 👤 Personnel',
    amigos: 'Amis',
    notificaciones: 'Notifications',
    marcar_todo_leido: 'Tout marquer comme lu',
    sin_notificaciones: "Tu n'as aucune notification",
    aceptar: '✅ Accepter',
    rechazar: '❌ Refuser',
    aceptar_eliminar: '🗑️ Accepter et supprimer',
    rechazar_simple: '✕ Refuser',
    ver_ahorro_responder: "📳 Voir l'épargne et répondre",
    alertas: 'Alertes',
    cerrar_sesion: 'Déconnexion',
    saludo_mundial: '🏆 Bienvenue,',
    saludo_normal: 'Salut,',
    bonzai_bot: 'BONZAI BOT 💬',
    alertas_pendientes_pre: '🚨 Tu as',
    alertas_pendientes_post: 'alerte(s) en attente',
    ahora_mismo: "à l'instant",
    muro_sugerencias: 'Voir le mur de suggestions',
    periodo_titulo: '📅 Choisis la période financière que tu veux !',
    periodo_desc: 'Filtre tes statistiques par mois ou affiche tout',
    vista_general_btn: '🌎 Vue générale',
    vista_mensual_btn: '📅 Vue mensuelle',
    resumen: 'Résumé',
    ingresos_totales: 'REVENUS TOTAUX',
    ingresos_del_mes: 'REVENUS DU MOIS',
    gastos_totales: 'DÉPENSES TOTALES',
    gastos_del_mes: 'DÉPENSES DU MOIS',
    tap_registrar_ingreso: 'TOUCHER POUR ENREGISTRER 💵',
    tap_registrar_gasto: 'TOUCHER POUR ENREGISTRER 🧾',
    balance_general: 'SOLDE GÉNÉRAL',
    balance_positivo: 'Tout va bien. Tes revenus gagnent le combat.',
    balance_negativo: 'Tes dépenses font un speedrun avec ton argent.',
    balance_neutro: 'Parfaitement équilibré... comme un portefeuille zen.',
    tap_ver_analisis: "TOUCHER POUR VOIR L'ANALYSE 📊",
    elemento_destacado: '🐷 ÉLÉMENT EN VEDETTE',
    meta: 'Objectif :',
    restante: 'Restant :',
    tap_ver_deudas: 'TOUCHER POUR VOIR LES DETTES ',
    tap_ver_ahorros: "TOUCHER POUR VOIR L'ÉPARGNE ",
    compartido: '👥 Partagé',
    tap_crear_ahorro: 'TOUCHER POUR CRÉER UNE ÉPARGNE 🐷',
    nav_calendario: 'Calendrier',
    nav_amigos: 'Amis',
    nav_mensajes: 'Messages',
    nav_ia: 'IA',
    cargando_mundial: 'Préparation du match...',
    cargando_normal: 'Chargement de tes informations...',

    //Ingresos
    ingresos_header: '💵 Revenus',
    volver: '← Retour',
    total_ingresos: 'Total des revenus',
    monto_placeholder: 'Montant',
    selecciona_categoria: 'Sélectionne une catégorie',
    cat_principales: '💼 Revenus principaux',
    cat_salario: 'Salaire',
    cat_honorarios: 'Honoraires',
    cat_negocio_propio: 'Entreprise personnelle',
    cat_adicionales: '✨ Revenus additionnels',
    cat_horas_extra: 'Heures supplémentaires',
    cat_comisiones: 'Commissions',
    cat_bonificaciones: 'Primes',
    cat_ocasionales: '🎁 Revenus occasionnels',
    cat_primas: 'Primes légales',
    cat_cesantias: 'Indemnité de licenciement',
    cat_regalos: "Cadeaux ou aides familiales",
    cat_personalizado: '➕ Personnalisé',
    cat_otro: 'Autre',
    titulo_categoria_placeholder: 'Titre de ta catégorie',
    descripcion_placeholder: 'Description',
    agregar_ingreso: 'Ajouter un revenu',
    csv_pregunta: 'Tu as déjà un CSV ?',
    csv_respuesta: "L'application le lira automatiquement !",
    csv_elige_banco: 'Choisis ta banque et téléverse le fichier',
    csv_importar_titulo: 'Importer un CSV',
    selecciona_pais: 'SÉLECTIONNE TON PAYS',
    selecciona_banco: 'SÉLECTIONNE TA BANQUE',
    cambiar_pais: 'Changer de pays',
    cargar_csv_de: 'Charger le CSV de',
    selecciona_banco_primero: "Sélectionne d'abord une banque",
    primero_selecciona_banco: "Sélectionne d'abord une banque",
    cerrar_modal: 'Fermer',
    ingresos_detectados: 'Revenus détectés',
    revisa_antes_importar: 'Vérifie avant d\'importer. Seuls les crédits/revenus sont inclus.',
    sin_descripcion: 'Sans description',
    importando: 'Importation...',
    importar_n_ingresos: 'Importer',
    cancelar: 'Annuler',
    filtrar_categoria: '🔍 Filtrer par catégorie',
    todas_categorias: 'Toutes les catégories',
    buscar_cat_personalizada: 'Rechercher une catégorie personnalisée...',
    escribir_nombre_cat: 'Écris le nom de la catégorie...',
    resultado: 'résultat',
    resultados: 'résultats',
    para_texto: 'pour',
    en_texto: 'dans',
    limpiar_filtro: '✕ Effacer le filtre',
    sin_ingresos_categoria: "Aucun revenu avec cette catégorie pour la période sélectionnée.",
    sin_ingresos: 'Aucun revenu enregistré',
    sin_categoria: 'Sans catégorie',
    guardar_edicion: '✔ Enregistrer',
    cancelar_edicion: '✖ Annuler',
    eliminar_registro_titulo: 'Supprimer cet enregistrement ?',
    eliminar_registro_desc: 'Cette action est irréversible.',
    si_eliminar: 'Oui, supprimer',

    //Gastos
    gastos_header: '💸 Dépenses',
    total_gastos: 'Total des dépenses',
    agregar_gasto: 'Ajouter une dépense',
    cat_fijos: '🏠 Dépenses fixes',
    cat_arriendo: 'Loyer',
    cat_administracion: 'Charges de copropriété',
    cat_servicios: '⚡ Services publics',
    cat_agua: 'Eau',
    cat_luz: 'Électricité',
    cat_gas: 'Gaz',
    cat_internet: 'Internet',
    cat_basicos: '🍽️ Dépenses de base',
    cat_mercado: 'Courses',
    cat_alimentacion: 'Alimentation',
    cat_transporte: 'Transport',
    cat_deudas: '💳 Dettes et obligations',
    cat_tarjetas: 'Cartes de crédit',
    cat_creditos: 'Crédits',
    cat_salud: '🏥 Santé et protection',
    cat_eps: 'Assurance santé',
    cat_medicina_prepagada: 'Médecine prépayée',
    cat_personales: '📱 Dépenses personnelles',
    cat_celular: 'Téléphone',
    cat_streaming: 'Streaming (Netflix, Spotify, etc.)',
    cat_ropa: 'Vêtements',
    cat_ocio: '🎉 Loisirs et style de vie',
    cat_salidas: 'Sorties (restaurants, cinéma, fête)',
    cat_viajes: 'Voyages',
    csv_pregunta_gastos: 'Tu as déjà un CSV ?',
    csv_respuesta_gastos: "L'application importera tes dépenses automatiquement !",
    gastos_detectados: 'Dépenses détectées',
    revisa_antes_importar_gastos: "Vérifie avant d'importer. Seuls les débits/dépenses sont inclus.",
    sin_gastos_categoria: "Aucune dépense avec cette catégorie pour la période sélectionnée.",
    sin_gastos: 'Aucune dépense enregistrée',
    importar_n_gastos: 'Importer',
    no_se_encontraron_gastos: "Aucune dépense valide n'a été trouvée. Vérifie que le fichier provient de",

    //Ahorros — header / general
    ahorros_header: '💰 Épargne / Dettes',
    ahorros_disponible: '💵 Disponible',
    ahorros_total_ahorrado: '🐷 Total épargné',
    ahorros_nuevo_btn: '➕ Nouvelle épargne ou dette',
    ahorros_loading_title: 'Épargne & Dettes',
    ahorros_loading_desc: 'Préparation de tes mouvements...',

    //Ahorros — secciones
    ahorros_personales: '👤 Personnelles',
    ahorros_compartidos: '👥 Partagées',
    ahorros_sin_compartidos: "Pas encore d'épargnes partagées",
    ahorros_sin_ahorros_titulo: "Pas encore d'épargnes",
    ahorros_sin_ahorros_desc: "Crée ta première épargne ou dette ci-dessus",

    //Ahorros — tipo
    ahorro_tipo_deuda: '🔴 Dette',
    ahorro_tipo_ahorro: '🟠 Épargne',
    ahorro_tipo_seguimiento_deuda: '🔴 Suivi de dette',
    ahorro_tipo_ahorro_compartido: '🟠 Épargne partagée',

    //Ahorros — compartidos / estados
    ahorro_pendiente: '⏳ En attente',
    ahorro_activo: '✅ Active',
    ahorro_compartido_badge: '👥 Partagée',
    ahorro_zumbido_btn: '📳 Bourdonnement',
    ahorro_zumbido_title: 'Envoyer un bourdonnement à',
    ahorro_con: 'Avec',
    ahorro_de: 'De',
    ahorro_solo_lectura: '👁 Lecture seule',
    ahorro_total_pagado: '💰 Total payé',
    ahorro_tu_aporte: 'Ta contribution',
    ahorro_su_aporte: 'Sa contribution',
    ahorro_esperando_acepte_pre: 'En attente que',
    ahorro_esperando_acepte_post: "accepte l'invitation",
    ahorro_tu_amigo: 'ton ami',

    //Ahorros — completados
    ahorros_completados_1: '1 terminée',
    ahorros_completados_n: '{n} terminées',
    ahorros_buscar_placeholder: '🔍 Rechercher...',
    ahorros_sin_resultados: 'Aucun résultat trouvé',
    ahorro_completado_badge: '🎉 Terminée',
    ahorro_eliminar_btn: '🗑️ Supprimer',

    //Ahorros — modal crear
    ahorro_modal_nuevo_ahorro: '🟠 Nouvelle épargne',
    ahorro_modal_nueva_deuda: '🔴 Nouvelle dette',
    ahorro_nombre_placeholder: 'Nom *',
    ahorro_descripcion_placeholder: 'Description (optionnel)',
    ahorro_meta_placeholder: 'Objectif en $ (optionnel)',
    ahorro_compartir_amigo: '👥 Partager avec un ami',
    ahorro_compartir_desc_deuda: 'Ton ami verra comment tu la rembourses',
    ahorro_compartir_desc_ahorro: 'Les deux peuvent contribuer',
    ahorro_sin_amigos: "⚠️ Tu n'as pas encore ajouté d'amis",
    ahorro_usuario_generico: 'Utilisateur',
    ahorro_id_label: 'ID :',
    ahorro_creando: 'Création...',
    ahorro_guardar_btn: '💾 Enregistrer',

    //Ahorros — modal movimiento personal
    ahorro_acumulado: 'accumulé',
    ahorro_monto_placeholder: '💰 Entre un montant',
    ahorro_comprobante_opcional: '📎 Justificatif (optionnel)',
    ahorro_subir_imagen: '📷 Télécharger une image',
    ahorro_subiendo: 'Téléchargement...',
    ahorro_meter_dinero: '➕ Ajouter de l\'argent',
    ahorro_sacar_dinero: '➖ Retirer de l\'argent',

    //Ahorros — confirmar eliminar
    ahorro_confirmar_eliminar_titulo: 'Supprimer cette épargne ?',
    ahorro_confirmar_eliminar_desc: "L'argent accumulé retournera à ton solde principal.",

    //Ahorros — modal movimiento compartido
    ahorro_historial: 'HISTORIQUE',
    ahorro_ver_comprobante_title: 'Voir le justificatif',
    ahorro_deuda_saldada: 'Dette remboursée !',
    ahorro_meta_alcanzada: 'Objectif atteint !',
    ahorro_pagaste_todo: 'Tu as tout payé. Libre de dettes ! 💪',
    ahorro_meta_lograda_juntos: "Vous avez atteint l'objectif ensemble. Félicitations ! 🚀",
    ahorro_comprobante_pago: '📎 Justificatif de paiement',
    ahorro_obligatorio: '* Obligatoire',
    ahorro_subir_comprobante: '📷 Télécharger le justificatif',
    ahorro_registrar_pago: '➕ Enregistrer le paiement',
    ahorro_solicitar_eliminacion: '🗑️ Demander la suppression',
    ahorro_modo_observador: 'Mode observateur',
    ahorro_modo_observador_desc: 'Seul le créateur peut enregistrer des paiements sur cette dette',

    //Ahorros — toasts
    toast_ahorro_ponle_nombre: "Donne un nom à l'épargne",
    toast_nombre_max_50: 'Le nom ne peut pas dépasser 50 caractères',
    toast_desc_max_200: 'La description ne peut pas dépasser 200 caractères',
    toast_selecciona_amigo: 'Sélectionne un ami',
    toast_error_crear: 'Erreur lors de la création',
    toast_solicitud_enviada_a: 'Demande envoyée à',
    toast_demasiadas_solicitudes: "Trop de demandes envoyées. Attends un moment avant de réessayer.",
    toast_cantidad_invalida: 'Montant invalide',
    toast_sin_dinero_disponible: "Tu n'as pas assez d'argent disponible",
    toast_sin_suficiente_ahorro: "Tu n'as pas assez dans cette épargne",
    toast_solo_hasta_meta: "Tu ne peux ajouter que jusqu'à {monto} pour atteindre l'objectif",
    toast_solo_creador_pagos_deuda: 'Seul le créateur peut enregistrer des paiements sur une dette',
    toast_debes_subir_comprobante: 'Tu dois télécharger un justificatif de paiement',
    toast_error_subir_comprobante: 'Erreur lors du téléchargement du justificatif',
    toast_excede_meta: "⚠️ Tu ne peux contribuer que jusqu'à {monto} pour atteindre l'objectif",
    toast_no_autorizado: "🚫 Tu n'as pas la permission d'enregistrer des paiements sur cette épargne",
    toast_solo_creador_deuda: '🚫 Seul le créateur peut enregistrer des paiements sur cette dette',
    toast_no_activo: "⚠️ Cette épargne n'est pas encore active",
    toast_no_existe: "⚠️ Cette épargne n'existe pas",
    toast_error_registrar_pago: "⚠️ Une erreur s'est produite lors de l'enregistrement du paiement",
    toast_demasiadas_solicitudes_warn: "⚠️ Trop de demandes envoyées. Attends un moment avant de réessayer.",
    toast_ahorro_eliminado: 'Épargne supprimée avec succès',
    toast_solicitud_eliminacion_enviada: "Demande de suppression envoyée. L'autre utilisateur doit l'accepter.",
    toast_zumbido_error: "⚠️ Impossible d'envoyer le bourdonnement, réessaie.",
    toast_zumbido_enviado: 'Bourdonnement envoyé ! 📳',
    toast_imagen_invalida: 'Seules les images JPG, PNG, WebP ou HEIC sont autorisées',
    toast_imagen_max_mb: "L'image ne peut pas dépasser {mb}Mo",

    //Ahorros — notificaciones guardadas para el otro usuario
    noti_invito_a_pre: "t'a invité à une",
    noti_seguimiento_deuda: 'suivi de dette',
    noti_ahorro_compartido: 'épargne partagée',
    noti_sin_descripcion: 'Sans description',
    noti_alguien: 'Quelqu\'un',
    noti_eliminar_titulo_pre: '🗑️',
    noti_quiere_eliminar: 'veut supprimer',
    noti_solicita_eliminar_pre: 'Demande de supprimer cette',
    noti_solicita_eliminar_post: 'terminée. Es-tu d\'accord ?',
    noti_tu_companero: 'Ton partenaire',
    noti_nuevo_aporte: 'Nouvelle',
    noti_aporte: 'contribution',
    noti_retiro: 'retrait',
    noti_en: 'dans',
    noti_aporto: 'a contribué',
    noti_retiro_verbo: 'a retiré',
    noti_toca_ver_comprobante: 'Touche pour voir le justificatif.',
    noti_zumbido_titulo: "T'a envoyé un Bourdonnement !",
    noti_revisa_tu: 'Vérifie ton :',
    //Alertas
    alertas_header: '⚠️ Alertes',
    alertas_activas: 'Alertes actives',
    alertas_nombre_placeholder: "Nom de l'alerte",
    alertas_valor_placeholder: 'Montant à payer',
    alertas_mora_placeholder: '% de pénalité quotidienne',
    alertas_crear_btn: "Créer l'alerte",
    alertas_sin_registradas: 'Aucune alerte enregistrée',
    alertas_valor_original: 'Montant original',
    alertas_mora_diaria: 'Pénalité quotidienne',
    alertas_fecha_limite: 'Date limite',
    alertas_retraso_pre: '⚠️ Retard de',
    alertas_retraso_post: 'jours',
    alertas_nuevo_valor: 'Nouveau montant :',
    alertas_confirmar_eliminar: 'Supprimer cette alerte ?',
    alertas_campos_obligatorios: 'Remplis tous les champs obligatoires',
    alertas_nombre_max_50: 'Le nom ne peut pas dépasser 50 caractères',
    alertas_desc_max_200: 'La description ne peut pas dépasser 200 caractères',
    toast_error_guardar_alerta: "Erreur lors de l'enregistrement de l'alerte",
    //Analíticas
    analiticas_header: '📊 Analytique',
    analiticas_subtitulo: 'Résumé financier intelligent',
    analiticas_cargando: 'Chargement des analyses...',
    analiticas_ingresos: 'Revenus',
    analiticas_gastos: 'Dépenses',
    analiticas_ahorro: 'Épargne',
    analiticas_mejor_mes: 'Meilleur mois',
    analiticas_rendimiento_anual: '📈 Performance annuelle',
    analiticas_recomendaciones: '🧠 Recommandations intelligentes',
    analiticas_mejor_mes_desc_pre: '💰 Ton meilleur mois était',
    analiticas_mejor_mes_desc_post: ', où tu as eu le plus de revenus.',
    analiticas_peor_mes_desc_pre: '⚠️ Ton mois avec le plus de dépenses était',
    analiticas_ahorro_total_pre: '🎯 Tu as actuellement épargné un total de',
    analiticas_ahorro_total_post: 'cette année.',
    consejo_gastos_superan: '⚠️ Tes dépenses dépassent tes revenus. Réduis les dépenses inutiles.',
    consejo_excelente: '🔥 Excellente gestion financière. Ton taux d\'épargne est très élevé.',
    consejo_vas_bien: '✅ Tu vas bien. Tu as une bonne capacité d\'épargne.',
    consejo_reducir_gastos: '💡 Essaie de réduire les petites dépenses quotidiennes pour améliorer ton épargne.',
    mes_ene: 'Jan', mes_feb: 'Fév', mes_mar: 'Mar', mes_abr: 'Avr',
    mes_may: 'Mai', mes_jun: 'Juin', mes_jul: 'Juil', mes_ago: 'Août',
    mes_sep: 'Sep', mes_oct: 'Oct', mes_nov: 'Nov', mes_dic: 'Déc',
    //Amigos
    amigos_sincronizando: 'Synchronisation des connexions...',
    amigos_volver: '← Retour',
    amigos_gestiona: 'Gère tes connexions',
    amigos_agregar_titulo: '➕ Ajouter un ami',
    amigos_agregar_desc: 'Partage ton ID avec quelqu\'un ou ajoute le sien.',
    amigos_tu_id: 'TON ID',
    amigos_sin_id_pre: "⚠️ Tu n'as pas encore créé d'ID d'ami.",
    amigos_sin_id_post: 'Va dans Profil et génère ton ID pour pouvoir ajouter des amis.',
    amigos_input_placeholder: "Entre l'ID de l'utilisateur",
    amigos_enviando: 'Envoi...',
    amigos_anadir_btn: '🚀 Ajouter un ami',
    amigos_solicitudes_titulo: '📩 Demandes en attente',
    amigos_sin_solicitudes: "Tu n'as aucune demande en attente",
    amigos_aceptar: '✅ Accepter',
    amigos_rechazar: '❌ Refuser',
    amigos_usuario_generico: 'Utilisateur',
    amigos_sin_id: 'Sans ID',
    amigos_tus_amigos_titulo: '👥 Tes amis',
    amigos_sin_amigos: "Tu n'as pas encore d'amis ajoutés",
    amigos_editar: '✏️ Modifier',
    amigos_eliminar: '🗑️ Supprimer',
    amigos_nombre_personalizado: '✏️ Nom personnalisé',
    amigos_alias_placeholder: 'Écris un alias',
    amigos_cancelar: 'Annuler',
    amigos_guardar_amigo: '💾 Enregistrer l\'ami',
    amigos_confirmar_eliminar_titulo: 'Supprimer cet ami ?',
    amigos_confirmar_eliminar_desc: 'Cette action est irréversible.',
    amigos_si_eliminar: 'Oui, supprimer',
    amigos_alert_ingresa_id: 'Entre un ID',
    amigos_alert_no_existe: 'Aucun utilisateur n\'existe avec cet ID',
    amigos_alert_no_agregarte: 'Tu ne peux pas t\'ajouter toi-même',
    amigos_alert_ya_existe: 'Une demande ou une amitié existe déjà',
    amigos_alert_error_enviar: 'La demande n\'a pas pu être envoyée',
    amigos_alert_demasiadas: '⚠️ Tu as envoyé trop de demandes à la suite. Attends une minute et réessaie.',
    amigos_alert_enviada: 'Demande envoyée 🚀',
    amigos_alert_nickname_max: 'Le nom personnalisé ne peut pas dépasser 30 caractères',
    amigos_alert_error_aceptar: 'La demande n\'a pas pu être acceptée',
    amigos_alert_amigo_agregado: '🎉 Ami ajouté',
    amigos_alert_error_eliminar: 'Impossible de supprimer cet ami',
    amigos_alert_amigo_eliminado: '🗑️ Ami supprimé',
    amigos_alert_error_rechazar: 'Impossible de refuser',
    //Mensajes
    mensajes_header: 'Messages',
    sin_conversaciones: 'Aucune conversation',
    agrega_amigos_chatear: 'Ajoute des amis pour discuter',
    sin_mensajes_aun: 'Pas encore de messages',
    tu_dos_puntos: 'Toi : ',
    no_hay_mensajes_decir_hola: 'Pas encore de messages. Dis bonjour ! 👋',
    escribir_mensaje_placeholder: 'Écris un message...',
    usuario_generico: 'Utilisateur',
    cargando_mensajes: 'Chargement des messages...',
    //Calendario
    cal_movimientos_dia: 'Mouvements du jour {dia}',
    cal_agregar_ingreso: '➕ Ajouter un revenu',
    cal_agregar_gasto: '➕ Ajouter une dépense',
    cal_no_hay_movimientos: 'Aucun mouvement',
    cal_mora_diaria_valor: 'Pénalité quotidienne : {pct}%',
    cal_seleccionar_fecha: '📅 Sélectionner une date',
    cal_mes_label: 'Mois',
    cal_anio_label: 'Année',
    cal_aplicar: 'Appliquer',
    cal_enero: 'Janvier', cal_febrero: 'Février', cal_marzo: 'Mars', cal_abril: 'Avril',
    cal_mayo: 'Mai', cal_junio: 'Juin', cal_julio: 'Juillet', cal_agosto: 'Août',
    cal_septiembre: 'Septembre', cal_octubre: 'Octobre', cal_noviembre: 'Novembre', cal_diciembre: 'Décembre',
    dia_lun: 'L', dia_mar: 'M', dia_mie: 'M', dia_jue: 'J', dia_vie: 'V', dia_sab: 'S', dia_dom: 'D',
    //BonzaiBot
    // ── Factura Scanner ──
    factura_btn_label: 'FACTURE',
    factura_tooltip: '📄 Scanner une facture (QR + IA)',
    factura_tomar_foto: '📸 Prendre une photo',
    factura_elegir_galeria: '🖼️ Choisir depuis la galerie',
    factura_ingresar_manual: '✏️ Saisir manuellement',
    factura_qr_detectado: '✅ QR détecté',
    factura_analizada: '🤖 Facture analysée',
    factura_ingresa_datos: '✏️ Saisis les informations',
    factura_no_pudo_leer: "Impossible de lire automatiquement. Complète les informations.",
    factura_verifica_datos: "Vérifie les informations avant d'enregistrer",
    factura_monto_total: 'MONTANT TOTAL *',
    factura_categoria_label: 'CATÉGORIE *',
    factura_nombre_categoria: 'NOM DE TA CATÉGORIE',
    factura_categoria_custom_placeholder: 'Ex. : Animaux, Gym, Cadeau...',
    factura_fecha_label: 'DATE',
    factura_desc_label: 'DESCRIPTION (optionnel)',
    factura_desc_placeholder: 'Ex. : Déjeuner',
    factura_registrar_gasto: '💸 Enregistrer la dépense',
    factura_cancelar: '✕ Annuler',
    factura_monto_invalido: 'Entre un montant valide',
    factura_usuario_no_identificado: 'Utilisateur non identifié',
    factura_selecciona_categoria_error: 'Sélectionne une catégorie',

    // ── Suggestion Box ──
    sugerencia_tooltip: 'Suggestions',
    sugerencia_titulo: '💡 Ta suggestion',
    sugerencia_placeholder: "Qu'aimerais-tu que nous améliorions ?",
    sugerencia_enviando: 'Envoi...',
    sugerencia_enviar: 'Envoyer la suggestion',
    sugerencia_muy_larga_titulo: 'Suggestion trop longue',
    sugerencia_muy_larga_desc: '500 caractères maximum',
    sugerencia_no_permitido_titulo: 'Non autorisé',
    sugerencia_no_permitido_desc: "Ta suggestion contient un contenu non autorisé",
    sugerencia_gracias_titulo: 'Merci !',
    sugerencia_gracias_desc: 'Ta suggestion a été envoyée 🙌',
    sugerencia_error_titulo: 'Erreur',
    sugerencia_error_desc: "Une erreur s'est produite, réessaie",

    // ── Home: fecha y mensajes dinámicos ──
    home_fecha_locale: 'fr-FR',
    bonzai_msg_1: "👀 Attention... cette alerte attend patiemment que tu ignores tes responsabilités.",
    bonzai_msg_2: "💸 Ton argent a dit : 'pitié, ne me fais pas payer de pénalité encore'.",
    bonzai_msg_3: '⏰ Le temps passe... et les factures aussi.',
    bonzai_msg_4: 'Cette alerte ne va pas se payer seule, champion.',
    bonzai_msg_5: '🚨 Alerte financière détectée : possible attaque de procrastination.',
    bonzai_msg_6: '😭 Ton futur toi est en train de te supplier de tout payer à temps.',
    saving_msg_1: "🫣 Ton toi financier attend une épargne, même de 5 000.",
    saving_msg_2: '💸 Créer une dette compte comme de l\'organisation... techniquement.',
    saving_msg_3: "😟 Ce dont tu rêves ne s'achètera pas seul si tu n'épargnes pas.",
    saving_msg_4: '🐷 Le cochon de la tirelire doit être aussi plein que toi.',
    saving_msg_5: '🚀 Une petite épargne reste toujours mieux que zéro.',
    saving_msg_6: '😎 Les objectifs financiers, ça compte aussi comme développement personnel.',
    saving_msg_7: '👻 Arrête les petites dépenses invisibles, commence à épargner.',
    income_msg_zero_1: '🫣 Ton portefeuille attend son grand moment.',
    income_msg_zero_2: '👀 Zéro revenu... le calme avant la tempête financière.',
    income_msg_zero_3: '🌵 Plus sec que le désert, mais tout peut changer.',
    income_msg_low_1: '🌱 Tout grand empire financier commence petit.',
    income_msg_low_2: '🐣 Tu es à peine en train de faire éclore ce flux de trésorerie.',
    income_msg_low_3: '🔋 Chargement des revenus... 12% complété.',
    income_msg_mid_1: '💸 Tu construis des revenus plutôt corrects.',
    income_msg_mid_2: '📈 Ça commence à ressembler à un plan.',
    income_msg_mid_3: '🙌 Pas mal, continue comme ça champion.',
    income_msg_high_1: '🚀 Ce flux d\'argent se sent déjà puissant.',
    income_msg_high_2: '👑 Tu es en mode magnat pour le moment.',
    income_msg_high_3: '🔥 Revenus en feu, dans le bon sens.',
    expense_msg_zero_1: "😎 Incroyable... pas un seul peso dépensé pour l'instant.",
    expense_msg_zero_2: "🧘 Calme total, ton argent n'a souffert de rien.",
    expense_msg_zero_3: '🛡️ Dépenses : 0. Tu es invincible (pour l\'instant).',
    expense_msg_low_1: '🧠 Tes dépenses restent plutôt sous contrôle.',
    expense_msg_low_2: '✅ Discipline financière niveau débutant réussi.',
    expense_msg_low_3: '🧊 Dépenses bien froides, tout est sous contrôle.',
    expense_msg_mid_1: "💸 Un peu d'argent est parti... mais tout est sous contrôle.",
    expense_msg_mid_2: '🌀 Les dépenses commencent à bouger, attention à ça.',
    expense_msg_mid_3: '🧾 Quelques factures ont décidé de rejoindre la fête.',
    expense_msg_high_1: '💀 Tes dépenses ont débloqué le mode légende.',
    expense_msg_high_2: '🔥 Ton portefeuille appelle à l\'aide.',
    expense_msg_high_3: "🌪️ Ce n'est plus une dépense, c'est un ouragan catégorie 5.",
    Escanear_facturaqr: "📄 Scanner la facture",
    perfil_loading_titulo: 'Profil',
    perfil_loading_desc: 'Préparation de ton espace personnel...',
    suscripcion_header: '💳 Abonnement',
    suscripcion_plan_nombre: 'Calypso abonnement',
    suscripcion_periodicidad: 'Facturation mensuelle',
    suscripcion_periodicidad_anual: 'Facturation annuelle',
    suscripcion_plan_mensual: 'Mensuel',
    suscripcion_plan_anual: 'Annuel',
    suscripcion_nota_conversion: 'Le paiement est traité en pesos colombiens (COP) au taux de change du jour.',
    suscripcion_beneficio_1: 'Analyses avancées illimitées',
    suscripcion_beneficio_2: 'Scan de factures illimité',
    suscripcion_beneficio_3: 'Épargnes partagées illimitées',
    suscripcion_beneficio_4: 'Support prioritaire',
    suscripcion_pagar_btn: '💳 Payer',
    suscripcion_procesando: 'Traitement...',
    suscripcion_error_generico: "Une erreur s'est produite. Réessaie.",
    suscripcion_error_widget: 'Impossible de charger le widget de paiement.',
    suscripcion_pago_aprobado: 'Paiement approuvé ! Ton abonnement sera activé sous peu.',
    suscripcion_pago_pendiente: 'Ton paiement est en attente de confirmation.',
    suscripcion_pago_rechazado: 'Paiement refusé. Essaie un autre moyen.',
    suscripcion_pago_error: "Un problème est survenu avec le paiement. Réessaie.",
    suscripcion_nota_seguridad: 'Paiements traités en toute sécurité.',
    suscripcion_perfil_titulo: 'Calypso abonné',
    suscripcion_perfil_desc: 'Débloque des fonctionnalités avancées',
    suscripcion_activa_badge: 'Active',
    suscripcion_vence_pre: 'Expire le',
    paywall_trial_titulo: '🎁 Tu es dans ton essai gratuit',
    paywall_vencido_titulo: '🔒 Ton essai gratuit est terminé',
    paywall_trial_desc_pre: 'Il te reste',
    paywall_trial_desc_post: "Cette fonctionnalité restera disponible ensuite si tu actives ton abonnement.",
    paywall_vencido_desc: "Active ton abonnement pour continuer à utiliser cette fonctionnalité et tous les outils de Calypso.",
    paywall_dia: 'jour',
    paywall_dias: 'jours',
    paywall_btn: '⭐ Voir l\'abonnement',
    // ── Créateurs ──
    creadores_header_titulo: 'Créateurs',
    creadores_header_subtitulo: "L'équipe derrière l'application",
    creadores_cerrar_btn: 'Fermer',
    creadores_apoyar_btn: 'Soutenir',
    creadores_kicker: 'Une histoire de code et de café',
    creadores_titulo_principal: '🚀 Merci d\'utiliser notre application',
    creadores_parrafo_1: "Cette application est née d'une idée simple : rendre la gestion de tes comptes facile, agréable et sans complications. Chaque écran, chaque animation, chaque détail a été pensé avec soin pour que tu puisses te concentrer sur l'essentiel.",
    creadores_parrafo_2: "Derrière tout cela, il y a de longues nuits, des tasses de café froides, des bugs qui apparaissent au pire moment, et l'immense satisfaction de voir fonctionner quelque chose que nous avons construit à partir de zéro. Nous ne sommes pas une grande entreprise et nous n'avons pas d'investisseurs. Nous sommes des personnes réelles qui ont parié sur ce projet.",
    creadores_fundadores_titulo: 'Fondateurs',
    creadores_dev_titulo: 'Développeur & Dev principal',
    creadores_dev_desc: "Design, code, tests, déploiement. Un seul cerveau derrière chaque fonctionnalité. Si quelque chose fonctionne bien, c'est lui. Si quelque chose plante... aussi lui. 😅",
    creadores_parrafo_3: "Chaque personne qui utilise l'application nous donne une raison de plus de continuer. Mais si tu veux aller plus loin et soutenir ce projet, toute contribution, aussi petite soit-elle, nous aide à payer les serveurs, le domaine et à continuer de construire.",
    creadores_parrafo_4: 'Merci, vraiment. Pas de cette façon générique "merci d\'utiliser notre produit". Merci vraiment, de personne à personne, d\'avoir fait confiance à quelque chose que nous avons fait de nos propres mains. 💜',
    creadores_footer_texto: 'Fait avec amour · Colombie 🇨🇴 ♥',
    creadores_panel_titulo: '☕ Choisis comment nous soutenir',
    creadores_banco_tipo_cuenta: 'Épargne',
    creadores_banco_numero_label: 'Numéro de compte',
    creadores_banco_titular_label: 'Titulaire',
    //Declaracion de Renta
    declaracion_renta_card_titulo: 'Déclaration de revenus (Colombie)',
    declaracion_renta_card_desc: "T'aide à organiser tes données pour ta déclaration de revenus en Colombie.",
    declaracion_renta_card_cta: 'TOUCHER POUR VOIR 🧾',

    declaracion_header: 'Déclaration de revenus',
    declaracion_aviso_colombia: '⚠️ Cette section s\'applique uniquement aux utilisateurs en Colombie.',
    declaracion_cedula_pedir: 'Avant de générer ton résumé, nous avons besoin de ton numéro de cédula.',
    declaracion_cedula_placeholder: 'Numéro de cédula',
    declaracion_guardar_cedula: 'Enregistrer la cédula',
    declaracion_guardando_cedula: 'Enregistrement...',
    declaracion_error_guardar_cedula: 'Impossible d\'enregistrer la cédula. Réessaie.',
    declaracion_periodo_titulo: 'Sélectionne la période à déclarer',
    declaracion_generar_btn: 'Générer le résumé automatique',
    declaracion_generando: 'Génération...',
    declaracion_falta_cedula_nota: 'Enregistre ta cédula ci-dessus pour générer le résumé.',
    declaracion_error_fechas: 'Sélectionne la période complète.',
    declaracion_error_generar: 'Impossible de générer le résumé. Réessaie.',
    declaracion_cedula_label: 'Cédula :',
    declaracion_periodo_label: 'Période :',
    declaracion_ingresos_label: 'REVENUS',
    declaracion_gastos_label: 'DÉPENSES',
    declaracion_neto_label: 'NET',
    declaracion_ingresos_por_categoria: 'Revenus par catégorie',
    declaracion_gastos_por_categoria: 'Dépenses par catégorie',
    declaracion_sin_ingresos_periodo: 'Aucun revenu pour cette période',
    declaracion_sin_gastos_periodo: 'Aucune dépense pour cette période',
    declaracion_imprimir_btn: '🖨️ Imprimer / Enregistrer en PDF',
    declaracion_cargando: 'Chargement...',
    declaracion_neto_nota: '(ce n\'est pas ton revenu imposable)',
    declaracion_topes_titulo: '📌 Dois-je déclarer ? Seuils de référence (année fiscale 2025)',
    declaracion_topes_texto: 'Tu dois déclarer si en 2025 tu as dépassé au moins un de ces seuils : patrimoine brut supérieur à 4 500 UVT (224 096 000 COP), revenus bruts égaux ou supérieurs à 1 400 UVT (69 719 000 COP), achats par carte, achats ou dépôts bancaires de plus de 1 400 UVT, ou si tu étais assujetti à la TVA. Ceci est indicatif, vérifie ton cas avec la DIAN ou un comptable.',
    declaracion_disclaimer: 'Ce résumé est un outil d\'aide généré par Calypso, en version bêta. Ce n\'est pas un document officiel de la DIAN, il n\'a aucune valeur fiscale et ne peut pas être présenté comme une déclaration de revenus. Les calculs et classifications sont indicatifs : vérifiez toujours l\'information avec un comptable ou directement sur le portail MUISCA avant de déclarer.',
    forgot_password_title: 'Mot de passe oublié ?',
    forgot_password_desc: 'Entrez votre e-mail et nous vous enverrons un lien pour créer un nouveau mot de passe.',
    forgot_password_email_label: 'E-mail',
    forgot_password_email_placeholder: 'votremail@exemple.com',
    forgot_password_error_required: "L'e-mail est requis",
    forgot_password_error_invalid: 'E-mail invalide',
    forgot_password_error_rate_limit: 'Trop de tentatives. Attendez quelques minutes et réessayez.',
    forgot_password_sending: 'Envoi en cours...',
    forgot_password_send_btn: 'Envoyer le lien →',
    forgot_password_back_login: '← Retour à la connexion',
    forgot_password_sent_title: 'Vérifiez votre e-mail',
    forgot_password_sent_desc: 'Si {email} est enregistré, vous recevrez un lien pour réinitialiser votre mot de passe.',
    forgot_password_sent_expire: 'Cliquez sur le lien dans l\'e-mail pour définir un nouveau mot de passe. Le lien expire dans {time}.',
    forgot_password_expire_time: '1 heure',
    forgot_password_no_email: "Vous n'avez pas reçu l'e-mail ? Vérifiez votre dossier spam ou",
    forgot_password_try_another: 'essayez un autre e-mail',
    login_error_email_required: "L'e-mail est requis",
    login_error_email_invalid: 'E-mail invalide',
    login_error_password_required: 'Le mot de passe est requis',
    login_error_invalid_credentials: 'E-mail ou mot de passe incorrect.',
    login_error_email_not_confirmed: 'Vous devez confirmer votre e-mail avant de vous connecter.',
    login_error_generic: "Une erreur s'est produite. Réessayez.",
    login_title: 'Bon retour',
    login_subtitle: 'Connectez-vous à votre compte pour continuer',
    login_email_label: 'E-mail',
    login_email_placeholder: 'votremail@exemple.com',
    login_password_label: 'Mot de passe',
    login_password_placeholder: 'Votre mot de passe',
    login_forgot_password: 'Mot de passe oublié ?',
    login_loading: 'Connexion...',
    login_submit: 'Se connecter →',
    login_no_account: "Vous n'avez pas de compte ?",
    login_register_link: 'Inscrivez-vous gratuitement',

    unlock_ahora_no: 'Pas maintenant',
    actualizacion_nunca: 'pas encore mis à jour',
    actualizacion_menos_1_min: 'il y a moins d\'une minute',
    actualizacion_minutos: 'il y a {n} minutes',
    actualizacion_horas: 'il y a {n} heures',
    suscripcion_trial_activa: "Essai gratuit · expire dans",
    suscripcion_trial_vencida: 'Votre essai gratuit est terminé · abonnez-vous pour continuer à utiliser Calypso',
    dia_singular: 'jour',
    dias_plural: 'jours',
    recargar_sesiones: 'Actualiser',

    modal_cerrar_sesiones_titulo: 'Fermer toutes les sessions sauf celle-ci ?',
    modal_cerrar_sesiones_desc: 'Vous devrez vous reconnecter sur vos autres appareils.',
    modal_cerrar_sesiones_confirmar: 'Oui, fermer les sessions',
    modal_cancelar: 'Annuler',
    modal_generar_id_titulo_ya: '⚠️ Vous avez déjà un ID',
    modal_generar_id_titulo_nuevo: "Générer un ID d'ami",
    modal_generar_id_desc_ya: 'Cela remplacera votre ID actuel. L\'ancien cessera de fonctionner.',
    modal_generar_id_desc_nuevo: 'Cela générera un ID unique pour que d\'autres puissent vous ajouter comme ami.',
    modal_generar_id_confirmar_ya: 'Oui, remplacer',
    modal_generar_id_confirmar_nuevo: 'Oui, générer',
    //I.A
    ia_analizando: 'Analyse de vos finances',
    ia_bienvenida: "Salut {name} ! 👋 Je suis votre assistant financier personnel.\n\nJ'ai chargé vos données financières des 3 derniers mois. Je peux vous aider à comprendre vos habitudes de dépenses, évaluer vos objectifs d'épargne et vous donner des conseils personnalisés basés sur vos données réelles.\n\nQue voulez-vous savoir aujourd'hui ? 💡",
    ia_error_procesar: "⚠️ Un problème est survenu lors du traitement de votre demande. Réessayez dans quelques secondes.",
    ia_sin_conexion_titulo: 'Pas de connexion internet',
    ia_sin_conexion_desc: "Vous devez être connecté à internet pour parler à votre assistant financier.",
    ia_volver_inicio: "Retour à l'accueil",
    ia_preparando_titulo: 'Préparation de votre assistant',
    ia_preparando_desc: 'Chargement de vos informations financières...',
    ia_header_titulo: 'Assistant financier',
    ia_header_estado: '● Actif · Répond uniquement sur vos finances',
    ia_datos_listos: '✓ Données prêtes',
    ia_ultimos_3_meses: '3 derniers mois',
    ia_privacidad_chip: '🔒 Vos données sont privées et ne sont pas stockées dans le chat',
    ia_preguntas_sugeridas: 'Questions suggérées',
    ia_input_placeholder: 'Posez une question sur vos finances...',
    ia_footer_hint: 'Répond uniquement aux questions sur vos finances personnelles · Entrée pour envoyer',
    ia_sugerencia_1: 'Comment vont mes finances ce mois-ci ?',
    ia_sugerencia_2: 'Sur quoi je dépense le plus ?',
    ia_sugerencia_3: 'Puis-je me permettre d\'épargner plus ?',
    ia_sugerencia_4: 'Où en sont mes objectifs d\'épargne ?',
    ia_sugerencia_5: 'Donne-moi un conseil pour réduire mes dépenses',
    ia_sugerencia_6: 'Quel est mon solde général ?',
    //FacturaEscaner
    factura_sin_internet_error: "Vous avez besoin d'une connexion internet pour scanner la facture.",
    factura_error_procesar_imagen: "Erreur lors du traitement de l'image :",
    factura_error_guardar: "Erreur lors de l'enregistrement :",
    factura_fuente_qr: 'Données du QR',
    factura_fuente_vision: 'Claude Vision',
    factura_fuente_manual: 'Manuel',
    factura_sin_logs: 'Aucun journal pour le moment...',
    factura_aria_escanear: 'Scanner la facture',
    factura_menu_sin_internet: 'Vous êtes hors ligne. Vous pourrez saisir les données manuellement une fois reconnecté.',
    factura_guia_titulo: 'Comment prendre la photo ?',
    factura_guia_tip_internet: "Vous avez besoin d'une connexion internet pour analyser la facture.",
    factura_guia_tip_1: 'Cadrez la ligne "TOTAL À PAYER" ou "MONTANT TOTAL"',
    factura_guia_tip_2: 'Assurez-vous que le texte soit net et bien éclairé',
    factura_guia_tip_3: 'Ne photographiez pas uniquement le code QR — il ne contient pas le montant',
    factura_guia_boton_foto: 'Prendre une photo',
    factura_analizando_titulo: 'Analyse de la facture...',
    factura_analizando_desc: 'Lecture de la facture avec Claude Vision...',
    factura_guardando_titulo: 'Enregistrement de la dépense...',
    factura_exito_titulo: 'Dépense enregistrée !',
    factura_exito_fuente: 'Source :',
    //Elimicacion de cuenta
    eliminar_cuenta_boton: 'Supprimer mon compte',
    eliminar_cuenta_titulo: 'Supprimer le compte Calypso',
    eliminar_cuenta_intro: 'Cette page vous permet de demander la suppression définitive de votre compte Calypso (Bonzzai Enterprise) et des données associées, conformément aux politiques de Google Play sur la suppression de compte.',
    eliminar_cuenta_que_titulo: 'Que sera supprimé ?',
    eliminar_cuenta_item1: 'Votre profil (nom, photo, e-mail)',
    eliminar_cuenta_item2: 'Revenus, dépenses et données financières enregistrées',
    eliminar_cuenta_item3: 'Épargnes partagées, alertes, messages et sessions actives',
    eliminar_cuenta_item4: 'Votre compte d\'authentification',
    eliminar_cuenta_aviso: 'Cette action est irréversible. Les données de facturation gérées par Google Play/RevenueCat sont conservées jusqu\'à 90 jours supplémentaires pour des exigences comptables et de prévention de la fraude.',
    eliminar_cuenta_login_req: 'Pour supprimer votre compte, connectez-vous d\'abord.',
    eliminar_cuenta_login_btn: 'Se connecter',
    eliminar_cuenta_continuar: 'Continuer la suppression',
    eliminar_cuenta_confirmar_texto: 'Tapez SUPPRIMER pour confirmer la suppression du compte de',
    eliminar_cuenta_confirmar_btn: 'Supprimer définitivement le compte',
    eliminar_cuenta_eliminando: 'Suppression...',
    eliminar_cuenta_exito: 'Votre compte a été supprimé',
    eliminar_cuenta_error: 'Le compte n\'a pas pu être supprimé',
    eliminar_cuenta_error_desc: 'Réessayez ou contactez-nous.',
    eliminar_cuenta_confirm_warning: 'Tapez SUPPRIMER pour confirmer',
    eliminar_cuenta_palabra_confirmacion: 'SUPPRIMER',
    eliminar_datos_titulo: 'Supprimer des données dans Calypso',
    eliminar_datos_intro: 'Calypso (Bonzzai Enterprise) vous permet de supprimer des données spécifiques de votre compte sans supprimer le compte entier. Les étapes pour chaque type de donnée sont détaillées ci-dessous.',
    eliminar_datos_transacciones_titulo: 'Transactions (revenus et dépenses)',
    eliminar_datos_transacciones_desc: 'Ouvrez l\'application → Revenus ou Dépenses → maintenez appuyé ou glissez sur l\'entrée → appuyez sur "Supprimer". La donnée est supprimée immédiatement de notre base de données.',
    eliminar_datos_foto_titulo: 'Photo de profil',
    eliminar_datos_foto_desc: 'Ouvrez Profil → survolez votre photo → appuyez sur l\'icône de la corbeille. L\'image est supprimée immédiatement de notre stockage.',
    eliminar_datos_sugerencias_titulo: 'Suggestions envoyées à la communauté',
    eliminar_datos_sugerencias_desc: 'Ouvrez la section Suggestions → trouvez votre suggestion → appuyez sur "Supprimer". Elle est supprimée immédiatement et n\'est plus visible pour les autres utilisateurs.',
    eliminar_datos_conservados: 'Données conservées :',
    eliminar_datos_conservados_desc: 'les données de facturation gérées par Google Play/RevenueCat sont conservées jusqu\'à 90 jours supplémentaires pour des exigences comptables et de prévention de la fraude.',
    eliminar_datos_pregunta_cuenta: 'Vous voulez supprimer tout votre compte plutôt que des données individuelles ?',
    eliminar_datos_link_cuenta: 'Allez ici',
    //YA ESTAS SUCRITO
    suscripcion_ya_suscrito_titulo: 'Vous êtes déjà abonné',
    suscripcion_activa_sin_fecha: 'Votre abonnement est actif.',
    suscripcion_gestionar_playstore: 'Gérer l\'abonnement sur Google Play',
    suscripcion_gestionar_soporte: 'Contacter le support pour gérer mon abonnement',
    //DECLARACION RENTA
    declaracion_ingresos_por_cedula: 'Revenus par catégorie fiscale',
    declaracion_revisar_manual_titulo: 'Vérification manuelle requise',
    declaracion_revisar_manual_desc: 'Ces revenus n\'ont pas pu être classés automatiquement. Vérifiez à quelle catégorie ils appartiennent avant de déclarer.',
    declaracion_cedula_trabajo: 'Revenus du travail',
    declaracion_cedula_capital: 'Revenus du capital',
    declaracion_cedula_no_laboral: 'Revenus non salariaux',
    declaracion_cedula_pensiones: 'Revenus de pension',
    declaracion_cedula_dividendos: 'Dividendes et participations',
    declaracion_cedula_ganancia_ocasional: 'Gains occasionnels',
    declaracion_cedula_no_clasificado: 'Non classé',
    declaracion_badge_beta: 'Bêta',
    declaracion_descargar_btn: 'Télécharger le résumé',
    declaracion_confirmar_descarga: 'Ce résumé est fourni à titre indicatif et ne remplace pas votre déclaration officielle auprès de la DIAN. Continuer ?',
    declaracion_requiere_suscripcion_titulo: 'Fonctionnalité réservée aux abonnés',
    declaracion_requiere_suscripcion_desc: 'Le résumé de déclaration de revenus est disponible uniquement pour les utilisateurs avec un abonnement actif (non inclus dans l\'essai gratuit).',
    declaracion_datos_adicionales_titulo: 'Données complémentaires pour votre déclaration',
    declaracion_datos_adicionales_desc: 'Ces données ne sont pas calculées à partir de vos transactions. Complétez-les manuellement pour obtenir un résumé plus proche de votre déclaration réelle.',
    declaracion_campo_patrimonio_bruto: 'Patrimoine brut (total des biens)',
    declaracion_campo_deudas: 'Dettes',
    declaracion_campo_retenciones: 'Retenues à la source déjà effectuées',
    declaracion_campo_aportes_pension: 'Cotisations volontaires à la retraite',
    declaracion_campo_aportes_afc: 'Cotisations au compte AFC',
    declaracion_campo_intereses_vivienda: 'Intérêts de crédit immobilier',
    declaracion_campo_medicina_prepagada: 'Assurance santé privée',
    declaracion_campo_dependientes: 'Nombre de personnes à charge',
    declaracion_error_cargar_datos_fiscales: 'Impossible de charger vos données fiscales.',
    declaracion_error_guardar_datos_fiscales: 'Impossible d\'enregistrer vos données fiscales.',
    declaracion_datos_guardados_ok: 'Données enregistrées avec succès.',
    declaracion_guardando: 'Enregistrement...',
    declaracion_guardar_datos: 'Enregistrer les données',
    declaracion_confirmar_descarga_titulo: 'Avant de continuer',
    declaracion_confirmar_descarga_btn: 'Oui, télécharger',
    declaracion_error_pdf: "Impossible de générer le PDF. Veuillez réessayer.",
    declaracion_generando_pdf: 'Génération du PDF...',
    // ── Modèles rapides : communs ──
    pl_boton: 'Rapides',
    pl_nueva: 'Nouveau modèle',
    pl_editar: 'Modifier le modèle',
    pl_agregar: 'Ajouter',
    pl_agregado_ok: 'Ajouté',
    pl_nota_fecha: 'Ils sont ajoutés avec la date d\'aujourd\'hui',
    pl_err_monto: 'Le montant doit être supérieur à 0',
    pl_err_categoria: 'Sélectionnez ou saisissez une catégorie',
    pl_err_categoria_larga: 'La catégorie ne peut pas dépasser 50 caractères',
    pl_err_desc_larga: 'La description ne peut pas dépasser 200 caractères',
    pl_err_guardar: 'Impossible d\'enregistrer le modèle',
    pl_err_agregar: 'Impossible d\'ajouter les enregistrements. Réessayez.',
    // ── Modèles rapides : revenus ──
    pl_titulo_ingreso: 'Revenus rapides',
    pl_desc_ingreso: 'Vos revenus fixes, prêts à ajouter en un clic',
    pl_vacio_ingreso: 'Vous n\'avez pas encore de revenus fixes. Créez-en un, comme votre salaire.',
    // ── Modèles rapides : dépenses ──
    pl_titulo_gasto: 'Dépenses rapides',
    pl_desc_gasto: 'Vos dépenses fixes, prêtes à ajouter en un clic',
    pl_vacio_gasto: 'Vous n\'avez pas encore de dépenses fixes. Créez-en une, comme votre loyer.',
  // ── Tutoriel ──
    tour_siguiente: 'Suivant',
    tour_anterior: 'Retour',
    tour_listo: 'Terminé !',
    tour_ayuda: 'Tutoriels',
    tour_ayuda_desc: 'Choisissez une section et nous vous guidons pas à pas',
    tour_menu_ingresos: 'Tutoriel des revenus',
    tour_menu_gastos: 'Tutoriel des dépenses',
    // Communs
    tour_mes_t: 'Changer de mois',
    tour_mes_d: 'Choisissez un autre mois pour voir et enregistrer les mouvements de cette période.',
    tour_import_t: 'Importez votre relevé avec l\'IA',
    tour_import_d: 'Envoyez le fichier de votre banque (CSV, TXT, XML ou PDF) et l\'IA détecte les mouvements pour vous. Appuyez sur Suivant pour voir comment.',
    tour_pais_t: 'Choisissez votre pays et envoyez le fichier',
    tour_pais_d: 'Sélectionnez votre pays pour que l\'IA comprenne le format des dates et de la monnaie, puis envoyez le relevé. Vous pourrez tout vérifier et modifier avant d\'importer.',
    tour_plantillas_t: 'Enregistrements rapides',
    tour_filtro_t: 'Filtrer par catégorie',
    tour_filtro_d: 'Affichez uniquement les mouvements d\'une catégorie ou cherchez-en une personnalisée.',
    // Revenus
    tour_ing_total_t: 'Vos revenus du mois',
    tour_ing_total_d: 'Voyez combien vous avez reçu dans le mois sélectionné. Touchez le graphique pour aller aux Analyses.',
    tour_ing_form_t: 'Enregistrer un revenu',
    tour_ing_form_d: 'Saisissez le montant, choisissez la date et la catégorie, ajoutez une description si vous voulez, puis touchez « Ajouter un revenu ».',
    tour_ing_lista_t: 'Vos revenus',
    tour_ing_lista_d: 'Les revenus du mois apparaissent ici. Avec ✏️ vous changez le montant et avec 🗑️ vous supprimez l\'enregistrement.',
    // Dépenses
    tour_gas_total_t: 'Vos dépenses du mois',
    tour_gas_total_d: 'Voyez combien vous avez dépensé dans le mois sélectionné. Touchez le graphique pour aller aux Analyses.',
    tour_gas_form_t: 'Enregistrer une dépense',
    tour_gas_form_d: 'Saisissez le montant, choisissez la date et la catégorie, ajoutez une description si vous voulez, puis touchez « Ajouter une dépense ».',
    tour_gas_lista_t: 'Vos dépenses',
    tour_gas_lista_d: 'Les dépenses du mois apparaissent ici. Avec ✏️ vous changez le montant et avec 🗑️ vous supprimez l\'enregistrement.',
    tour_plantillas_d: 'Gardez ici vos mouvements fixes, comme le salaire ou le loyer. Touchez Suivant et nous l\'ouvrons pour vous.',
    tour_pl_nueva_t: 'Créez un modèle',
    tour_pl_nueva_d: 'Ce bouton sert à créer un mouvement fixe. Nous vous montrons maintenant le formulaire.',
    tour_pl_form_t: 'Remplissez votre modèle',
    tour_pl_form_d: 'Essayez : saisissez le montant, choisissez la catégorie et, si vous voulez, une description (par exemple « Salaire »). Si vous l\'enregistrez, ce sera votre premier modèle. Ou touchez Suivant pour continuer sans enregistrer.',       
    tour_pl_lista_t: 'Vos modèles',
    tour_pl_lista_d: 'Ceux que vous avez créés apparaissent ici. Cochez ou décochez ceux que vous voulez ajouter, et utilisez ✏️ pour les modifier ou 🗑️ pour les supprimer.',
    tour_pl_agregar_t: 'Ajoutez-les en un clic',
    tour_pl_agregar_d: 'Ce bouton ajoute instantanément tous les modèles cochés, avec la date du jour et sans rien saisir.',
    tour_menu_home: "Tutoriel de l'accueil",
    tour_menu_ahorro: 'Tutoriel Épargne et Dettes',
    // Accueil
    tour_home_bienvenida_t: 'Bienvenue sur Calypso !',
    tour_home_bienvenida_d: "Faisons un petit tour de l'accueil. Appuyez sur Suivant pour commencer.",
    tour_home_periodo_t: 'Choisissez votre période',
    tour_home_periodo_d: 'Voyez vos chiffres par mois ou passez à la vue générale pour tout votre historique.',
    tour_home_ingresos_t: 'Vos revenus',
    tour_home_ingresos_d: 'Ce que vous avez reçu sur la période. Touchez la carte pour enregistrer un revenu.',
    tour_home_gastos_t: 'Vos dépenses',
    tour_home_gastos_d: 'Ce que vous avez dépensé sur la période. Touchez la carte pour enregistrer une dépense.',
    tour_home_balance_t: 'Votre solde',
    tour_home_balance_d: 'Revenus moins dépenses. Touchez la carte pour voir vos analyses.',
    tour_home_ahorro_t: 'Épargne et dettes',
    tour_home_ahorro_d: "Votre épargne ou dette en vedette défile ici avec sa progression. Touchez la carte pour les gérer.",
    tour_home_renta_t: 'Déclaration de revenus',
    tour_home_renta_d: 'Organisez vos données pour déclarer vos revenus en Colombie.',
    tour_home_herr_t: 'Outils rapides',
    tour_home_herr_d: 'Scannez une facture, envoyez une suggestion ou consultez le mur de suggestions de la communauté.',
    tour_home_extras_t: "Plus d'options",
    tour_home_extras_d: 'Cette flèche déploie la barre avec vos notifications et alertes. Touchez Suivant et nous l\'ouvrons pour vous.',
    tour_home_notif_t: 'Notifications',
    tour_home_notif_d: 'La cloche vous prévient des demandes d\'amis, épargnes partagées, messages et bourdonnements. Le chiffre rouge indique celles non lues.',
    tour_home_panel_t: 'Votre boîte',
    tour_home_panel_d: 'Vos notifications apparaissent ici. Vous pouvez accepter ou refuser des demandes, tout marquer comme lu ou en supprimer une avec ✕.',
    tour_home_alertas_t: 'Alertes',
    tour_home_alertas_d: "Vos rappels de paiement avec date limite et pénalités. Elle tremble quand des alertes sont en attente.",
    tour_home_perfil_t: 'Votre profil',
    tour_home_perfil_d: 'Votre photo ou initiale mène au profil : langue, couleurs, devise, thèmes et sessions.',
    tour_home_nav_t: 'Navigation',
    tour_home_nav_d: "D'ici, accédez au calendrier, aux amis, aux messages et à l'assistant IA.",
    // Épargne
    tour_aho_resumen_t: 'Votre résumé',
    tour_aho_resumen_d: "Disponible est l'argent libre de votre solde et Total épargné est ce que vous avez mis de côté.",
    tour_aho_nuevo_t: 'Créez une épargne ou une dette',
    tour_aho_nuevo_d: 'Ce bouton en crée une nouvelle. Touchez Suivant et nous vous montrons le formulaire (rien n\'est enregistré).',
    tour_aho_tipo_t: 'Épargne ou dette',
    tour_aho_tipo_d: "Choisissez s'il s'agit d'un objectif d'épargne ou d'une dette à rembourser.",
    tour_aho_datos_t: 'Les informations',
    tour_aho_datos_d: 'Donnez un nom, une description facultative et un objectif en pesos facultatif pour suivre votre progression.',
    tour_aho_compartir_t: 'Partagez avec un ami',
    tour_aho_compartir_d: "Activez cette option pour épargner avec un ami, ou pour qu'il voie comment vous remboursez une dette. Votre ami doit accepter l'invitation.",
    tour_aho_personales_t: 'Vos épargnes personnelles',
    tour_aho_personales_d: 'Chaque carte montre le cumul, l\'objectif et la progression. Touchez-en une pour ajouter ou retirer de l\'argent. Nous vous montrons comment.',
    tour_aho_mov_monto_t: 'Saisissez le montant',
    tour_aho_mov_monto_d: 'Indiquez combien ajouter ou retirer. Ajouter déduit de votre disponible et retirer le rend.',
    tour_aho_mov_comprobante_t: 'Justificatif',
    tour_aho_mov_comprobante_d: "Joignez si vous voulez une photo du justificatif. Pour les épargnes partagées, il est obligatoire.",
    tour_aho_mov_acciones_t: 'Actions',
    tour_aho_mov_acciones_d: "Ajoutez ou retirez de l'argent, ou supprimez l'épargne (le cumul retourne à votre solde).",
    tour_aho_compartidos_t: 'Épargnes partagées',
    tour_aho_compartidos_d: "Ici, vos épargnes avec des amis : la contribution de chacun, la progression et le bouton 📳 Bourdonnement pour relancer votre ami. Les terminées sont rangées sous 🎉, et les dettes partagées sont en lecture seule pour qui ne les a pas créées.",
    tour_aho_vacio_t: "Pas encore d'épargnes",
    tour_aho_vacio_d: 'Quand vous créerez votre première épargne ou dette, elle apparaîtra ici. Rouvrez ce tutoriel et nous vous montrerons comment les gérer.',
    //NUEVOS TEMAS
    saludo_halloween: '🎃 Joyeux Halloween,',
    saludo_navidad: '🎄 Joyeux Noël,',
    saludo_colombia: '☕ Salut,',
    saludo_cerveza: '🍺 Santé,',
    cargando_halloween: 'Réveil des fantômes...',
    cargando_navidad: 'Accrochage des guirlandes...',
    cargando_colombia: 'Préparation du café...',
    cargando_cerveza: 'Service de la mousse...',
    tema_worldcup_nombre: 'Coupe du monde 2026',
    tema_worldcup_desc: "Stades, football, trophées et ambiance de Coupe du monde.",
    tema_halloween_nombre: 'Halloween',
    tema_halloween_desc: 'Citrouilles, fantômes et nuits effrayantes.',
    tema_navidad_nombre: 'Noël',
    tema_navidad_desc: "Neige, lumières et esprit de Noël.",
    tema_colombia_nombre: 'Colombie',
    tema_colombia_desc: 'Café, montagnes et les couleurs du drapeau.',
    tema_cerveza_nombre: 'Bière',
    tema_cerveza_desc: 'Mousse, trinquons et bonne fête.',
    tema_badge_desbloqueado: 'Thème débloqué !',
    tema_aplicar: '✨ Appliquer le thème',
    tema_toast_desbloqueado: 'Thème débloqué',
    tema_toast_desbloqueado_desc: '{tema} est maintenant disponible dans ton profil.',
  },   // ← cierra fr
}